
      var $parcel$global = globalThis;
    function $fa7a60d60ed0fb7b$export$db4f8e1f9297af79() {
    // 🟢 Buttons
    const [btnAdopt, btnVolunteer, btnDonate] = document.querySelectorAll(".key-link .key-links");
    const btnBreeds = document.querySelector(".breeds-btn");
    const btnBlog = document.querySelector(".modal-blog");
    const petGallery = document.querySelector(".modal-gallery");
    const petCalendar = document.querySelector(".modal-calendar");
    const btnVetShelter = document.querySelector(".modal-vetshelter");
    // 🟣 Modals
    const [adoptModal, volunteerModal, donateModal] = document.querySelectorAll(".form-container, .volunteer-form, .donate-form");
    const breedsModal = document.querySelector(".breeds-modal");
    const blogModal = document.querySelector(".pet-blog");
    const galleryModal = document.querySelector(".pet-gallery");
    const calendarModal = document.querySelector(".pet-calendar");
    const vetShelterModal = document.querySelector(".pet-vetshelter");
    // 🔴 Close buttons
    const closeAdopt = adoptModal?.querySelector(".btn-close");
    const closeVolunteer = volunteerModal?.querySelector(".btn-close");
    const closeDonate = donateModal?.querySelector(".btn-close");
    const closeBreeds = breedsModal?.querySelector(".btn-close");
    const closeBlog = blogModal?.querySelector(".btn-close");
    const closeGallery = galleryModal?.querySelector(".btn-close");
    const closeCalendar = calendarModal?.querySelector(".btn-close");
    const closeVetShelter = vetShelterModal?.querySelector(".btn-close");
    // ⚫ Overlay
    const overlay = document.querySelector(".overlay");
    // 🧩 Put all modals together for easy iteration
    const modals = [
        adoptModal,
        volunteerModal,
        donateModal,
        breedsModal,
        blogModal,
        galleryModal,
        calendarModal,
        vetShelterModal
    ];
    if (!overlay) return;
    // 🐾 OPEN handlers
    btnAdopt?.addEventListener("click", (e)=>openHandler(e, adoptModal));
    btnVolunteer?.addEventListener("click", (e)=>openHandler(e, volunteerModal));
    btnDonate?.addEventListener("click", (e)=>openHandler(e, donateModal));
    btnBreeds?.addEventListener("click", (e)=>openHandler(e, breedsModal));
    btnBlog?.addEventListener("click", (e)=>openHandler(e, blogModal));
    petGallery?.addEventListener("click", (e)=>openHandler(e, galleryModal));
    petCalendar?.addEventListener("click", (e)=>openHandler(e, calendarModal));
    btnVetShelter?.addEventListener("click", (e)=>openHandler(e, vetShelterModal));
    // ❌ CLOSE handlers
    [
        closeAdopt,
        closeVolunteer,
        closeDonate,
        closeBreeds,
        closeBlog,
        closeGallery,
        closeCalendar,
        closeVetShelter
    ].forEach((btn, i)=>{
        btn?.addEventListener("click", ()=>closeModal(modals[i]));
    });
    // 🕳️ Overlay click closes all modals
    overlay.addEventListener("click", ()=>modals.forEach(closeModal));
    // ⌨️ ESC key closes all modals
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") modals.forEach(closeModal);
    });
    // 🔹 Helper functions
    function openHandler(e, modal) {
        e.preventDefault();
        openModal(modal);
    }
    function openModal(modal) {
        if (!modal) return;
        modal.classList.add("active");
        overlay.classList.add("active");
        modal.style.display = "block";
        overlay.style.display = "block";
        document.body.style.overflow = "hidden"; // disable page scroll
    }
    function closeModal(modal) {
        if (!modal) return;
        modal.classList.remove("active");
        overlay.classList.remove("active");
        setTimeout(()=>{
            modal.style.display = "none";
            overlay.style.display = "none";
        }, 100);
        document.body.style.overflow = ""; // re-enable scroll
    }
}


'use strict';
'use strict';
var $ca3e1754e676956d$exports = {};
'use strict';
var $3fbf1185731afe2b$exports = {};
'use strict';
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$3fbf1185731afe2b$exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == 'object' && globalThis) || $3fbf1185731afe2b$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == 'object' && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == 'object' && $parcel$global) || $3fbf1185731afe2b$var$check(typeof $3fbf1185731afe2b$exports == 'object' && $3fbf1185731afe2b$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
'use strict';
var $ef322a7f89c3ed41$exports = {};
'use strict';
var $6140c9fa18232846$exports = {};
'use strict';
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
'use strict';
var $bcbe62e89adc7d37$exports = {};
'use strict';

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
'use strict';
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
'use strict';
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
'use strict';
var $8239f4c7c6082668$exports = {};
'use strict';
var $43b18aa2f1faac44$exports = {};
'use strict';

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
'use strict';

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === 'String' ? $8239f4c7c6082668$var$split(it, '') : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
'use strict';
var $7ce250ddf7b42d4d$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
'use strict';
var $8ffb6b36a733d3c0$exports = {};
'use strict';

var $6a130d390db46c8e$exports = {};
'use strict';
var $70e34a5a2021f756$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == 'undefined' && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == 'object' ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
'use strict';
var $a5217dbd1b0d33ce$exports = {};
'use strict';


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($3fbf1185731afe2b$exports[namespace]) : $3fbf1185731afe2b$exports[namespace] && $3fbf1185731afe2b$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
'use strict';

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
'use strict';
var $4a39565fee8fe980$exports = {};
'use strict';
var $b2a56c1a090208a5$exports = {};
'use strict';

var $34fa2a1382dc63c1$exports = {};
'use strict';

var $34fa2a1382dc63c1$var$navigator = $3fbf1185731afe2b$exports.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
$34fa2a1382dc63c1$exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : '';


var $b2a56c1a090208a5$var$process = $3fbf1185731afe2b$exports.process;
var $b2a56c1a090208a5$var$Deno = $3fbf1185731afe2b$exports.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $34fa2a1382dc63c1$exports) {
    $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
$b2a56c1a090208a5$exports = $b2a56c1a090208a5$var$version;




var $4a39565fee8fe980$var$$String = $3fbf1185731afe2b$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b2a56c1a090208a5$exports && $b2a56c1a090208a5$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports('Symbol');
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
'use strict';
var $ae485921c5498156$exports = {};
'use strict';

var $8f0ebae34f61e14c$exports = {};
'use strict';
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
'use strict';



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
'use strict';

var $1946b9b54b48e7fd$exports = {};
'use strict';
var $d00d03e557d638db$exports = {};
'use strict';
var $e0409817d4e03fc4$exports = {};
'use strict';
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($3fbf1185731afe2b$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3fbf1185731afe2b$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = '__core-js_shared__';
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $3fbf1185731afe2b$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: '3.46.0',
    mode: $e0409817d4e03fc4$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.46.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
'use strict';

var $a2f3ebb5da11db12$exports = {};
'use strict';

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
'use strict';

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.1.toString);
$5e0a1e292f79defc$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports('wks');
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol['for'] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol('Symbol.' + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, 'string');
    return $0b429cc7792c7d26$exports(key) ? key : key + '';
};



var $d45526d8245cb22c$exports = {};
'use strict';


var $15c0c414b89100b1$exports = {};
'use strict';


var $15c0c414b89100b1$var$document = $3fbf1185731afe2b$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
'use strict';


var $161a89d67c436ccf$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
'use strict';

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + ' is not an object');
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = 'enumerable';
var $2d0ac3aa5e39584b$var$CONFIGURABLE = 'configurable';
var $2d0ac3aa5e39584b$var$WRITABLE = 'writable';
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
'use strict';


var $09c56ff2ae09b2d7$exports = {};
'use strict';





var $81c64883d194e3b4$exports = {};
'use strict';


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === 'something';
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, 'name').configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
'use strict';



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
'use strict';
var $47d53bb84a8f3c5b$exports = {};
'use strict';


var $47d53bb84a8f3c5b$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
'use strict';


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports('keys');
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
'use strict';
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $3a8bcef306e86159$var$TypeError = $3fbf1185731afe2b$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports('state');
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports(''.replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split('String');
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$1f868a26fd901990$exports(value, 'name') || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, 'arity') && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, 'constructor') && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, 'source')) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, 'toString');



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
'use strict';

var $339f2419d379e6c2$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
'use strict';
var $c4fba4611365c4f5$exports = {};
'use strict';



var $f00609c516640f24$exports = {};
'use strict';

var $1ef9432c43157f41$exports = {};
'use strict';
var $b5bb21648546ce5b$exports = {};
'use strict';
var $5395b5a4913a5e32$exports = {};
'use strict';
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
'use strict';
var $4aba983aae3daed3$exports = {};
'use strict';

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
'use strict';
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat('length', 'prototype');
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
'use strict';
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
'use strict';


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, '.').toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = 'N';
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = 'P';
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3fbf1185731afe2b$exports;
    else if (STATIC) target = $3fbf1185731afe2b$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $3fbf1185731afe2b$exports[TARGET] && $3fbf1185731afe2b$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, 'sham', true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};



var $a393da0e05d61ed1$exports = {};
'use strict';

var $3cdb2ef65d8e3cb5$exports = {};
'use strict';

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == 'object' && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});


var $43284f0171045916$exports = {};
'use strict';
var $4828cb1b4c7586c8$exports = {};
'use strict';


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === 'Function') return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $b8ce1ad1b6b1e7c1$exports = {};
'use strict';

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports('document', 'documentElement');


var $0709cba658bb4ed6$exports = {};
'use strict';

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);



var $7d824954c5058f7d$exports = {};
'use strict';
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError('Not enough arguments');
    return passed;
};


var $2d59c67a15180939$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$2d59c67a15180939$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($34fa2a1382dc63c1$exports);


var $88d6935be735e2e8$exports = {};
'use strict';
var $87e21695405add0a$exports = {};
'use strict';



var $87e21695405add0a$var$userAgentStartsWith = function(string) {
    return $34fa2a1382dc63c1$exports.slice(0, string.length) === string;
};
$87e21695405add0a$exports = function() {
    if ($87e21695405add0a$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($87e21695405add0a$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($87e21695405add0a$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($87e21695405add0a$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($3fbf1185731afe2b$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($3fbf1185731afe2b$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($b0ba63bfbfb16088$exports($3fbf1185731afe2b$exports.process) === 'process') return 'NODE';
    if ($3fbf1185731afe2b$exports.window && $3fbf1185731afe2b$exports.document) return 'BROWSER';
    return 'REST';
}();


$88d6935be735e2e8$exports = $87e21695405add0a$exports === 'NODE';


var $a393da0e05d61ed1$var$set = $3fbf1185731afe2b$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $3fbf1185731afe2b$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $3fbf1185731afe2b$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $3fbf1185731afe2b$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $3fbf1185731afe2b$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $3fbf1185731afe2b$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $3fbf1185731afe2b$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $3fbf1185731afe2b$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $3fbf1185731afe2b$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + '//' + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($88d6935be735e2e8$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$2d59c67a15180939$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($3fbf1185731afe2b$exports.addEventListener && $70e34a5a2021f756$exports($3fbf1185731afe2b$exports.postMessage) && !$3fbf1185731afe2b$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== 'file:' && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $3fbf1185731afe2b$exports.addEventListener('message', $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports('script')) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports('script'))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


'use strict';



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
'use strict';







var $f112a170991e44cc$var$Function = $3fbf1185731afe2b$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($34fa2a1382dc63c1$exports) || $87e21695405add0a$exports === 'BUN' && function() {
    var version = $3fbf1185731afe2b$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $3fbf1185731afe2b$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}


const $ba30e20475feac5a$export$ca6dda5263526f75 = 'https://dog.ceo/api';
const $ba30e20475feac5a$export$c471e1325171db6d = 2000; // in milliseconds (2 seconds)
const $ba30e20475feac5a$export$9d5cf83ce5f62ace = 7000; // in milliseconds (7 seconds)


// ⏱ Generic fetch with timeout helper
async function $d322b1c958656062$var$fetchWithTimeout(url, timeout = (0, $ba30e20475feac5a$export$9d5cf83ce5f62ace)) {
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    try {
        const res = await fetch(url, {
            signal: controller.signal
        });
        clearTimeout(id);
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return await res.json();
    } catch (error) {
        if (error.name === "AbortError") throw new Error("Request timed out. Please try again later.");
        throw error;
    }
}
async function $d322b1c958656062$export$74b7fa354111de1c() {
    try {
        const data = await $d322b1c958656062$var$fetchWithTimeout(`${(0, $ba30e20475feac5a$export$ca6dda5263526f75)}/breeds/list/all`, (0, $ba30e20475feac5a$export$9d5cf83ce5f62ace));
        console.log(data);
        return data.message;
    } catch (error) {
        console.error("Failed to fetch breeds:", error);
        throw error;
    }
}
async function $d322b1c958656062$export$a97658d36297bf4c(breed) {
    try {
        const data = await $d322b1c958656062$var$fetchWithTimeout(`${(0, $ba30e20475feac5a$export$ca6dda5263526f75)}/breed/${breed}/images/random`, (0, $ba30e20475feac5a$export$9d5cf83ce5f62ace));
        console.log(data);
        return data.message;
    } catch (error) {
        console.error(`Failed to fetch dog for ${breed}:`, error);
        throw error;
    }
}



function $796c3155ab639a9c$export$4e45a93c820471fa() {
    const counters = document.querySelectorAll('.stat-data');
    let started = false; // To prevent re-triggering when scrolled again
    // Intersection Observer to trigger counting when visible
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && !started) {
                started = true;
                counters.forEach((counter)=>{
                    let startValue = 0;
                    const endValue = parseInt(counter.getAttribute('data-val'));
                    const increment = Math.ceil(endValue / ((0, $ba30e20475feac5a$export$c471e1325171db6d) / 50)); // dynamic increment// adjust increment based on duration
                    function updateCount() {
                        startValue += increment;
                        counter.textContent = startValue;
                        if (startValue < endValue) setTimeout(updateCount, 50);
                        else counter.textContent = endValue; // ensure exact value at the end
                    }
                    updateCount();
                });
                observer.disconnect(); // stop observing after animation starts
            }
        });
    }, {
        threshold: 0.4
    }); // Trigger when 40% visible
    const section = document.querySelector('.stats');
    if (section) observer.observe(section);
}



async function $050486e8e3cb883c$export$f0c7f3aad087f331(galleryContainer, loaderElement, limit = 15) {
    if (!galleryContainer || !loaderElement) {
        console.error("Gallery or loader element not found!");
        return;
    }
    loaderElement.textContent = "Loading gallery... \uD83D\uDC3E";
    try {
        const breeds = await (0, $d322b1c958656062$export$74b7fa354111de1c)();
        loaderElement.textContent = "";
        // ✅ Limit how many breeds to display
        const breedNames = Object.keys(breeds).slice(0, limit);
        for (const breed of breedNames)try {
            const dogUrl = await (0, $d322b1c958656062$export$a97658d36297bf4c)(breed);
            const item = $050486e8e3cb883c$var$createGalleryItem(breed, dogUrl);
            galleryContainer.appendChild(item);
        } catch (err) {
            console.error(`Failed to load image for ${breed}`, err);
        }
    } catch (error) {
        loaderElement.textContent = error.message || "Failed to load gallery.";
    }
}
/* 🐕 Create gallery card element */ function $050486e8e3cb883c$var$createGalleryItem(breed, imageUrl) {
    const item = document.createElement("div");
    item.classList.add("gallery-item");
    item.innerHTML = `
    <img src="${imageUrl}" alt="${breed}">
    <div class="info">
      <h3>${breed}</h3>
      <p>Dog Breed</p>
    </div>
  `;
    return item;
}


var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$t, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c = {}, $13c40c34b78c8ee2$var$s = [], $13c40c34b78c8ee2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $13c40c34b78c8ee2$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$p(l, f, t, r, null);
}
function $13c40c34b78c8ee2$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $13c40c34b78c8ee2$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $13c40c34b78c8ee2$var$g(n, r, l[r], u[r], i);
}
function $13c40c34b78c8ee2$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$a.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $13c40c34b78c8ee2$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $13c40c34b78c8ee2$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $13c40c34b78c8ee2$var$w : $13c40c34b78c8ee2$var$m, r) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$w : $13c40c34b78c8ee2$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $13c40c34b78c8ee2$var$m(n) {
    $13c40c34b78c8ee2$var$t = !0;
    try {
        return this.l[n.type + !1]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $13c40c34b78c8ee2$var$t = !1;
    }
}
function $13c40c34b78c8ee2$var$w(n) {
    $13c40c34b78c8ee2$var$t = !0;
    try {
        return this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $13c40c34b78c8ee2$var$t = !1;
    }
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$A(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$A(n) : null;
}
function $13c40c34b78c8ee2$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$P(n);
    }
}
function $13c40c34b78c8ee2$var$C(n) {
    $13c40c34b78c8ee2$var$t ? setTimeout(n) : $13c40c34b78c8ee2$var$f(n);
}
function $13c40c34b78c8ee2$var$T(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$r.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$C)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    var n, l, u, i, t, o, f, e;
    for($13c40c34b78c8ee2$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $13c40c34b78c8ee2$var$r.shift();)n.__d && (l = $13c40c34b78c8ee2$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $13c40c34b78c8ee2$var$h({}, o)).__v = o.__v + 1, $13c40c34b78c8ee2$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $13c40c34b78c8ee2$var$A(o) : f, o.__h), $13c40c34b78c8ee2$var$N(i, o), o.__e != f && $13c40c34b78c8ee2$var$P(o)), $13c40c34b78c8ee2$var$r.length > l && $13c40c34b78c8ee2$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $13c40c34b78c8ee2$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $13c40c34b78c8ee2$var$p(null, d, null, null, d) : Array.isArray(d) ? $13c40c34b78c8ee2$var$p($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $13c40c34b78c8ee2$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $13c40c34b78c8ee2$var$M(n, d, y = y || $13c40c34b78c8ee2$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $13c40c34b78c8ee2$var$I(d, e, n) : e = $13c40c34b78c8ee2$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $13c40c34b78c8ee2$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $13c40c34b78c8ee2$var$L(i).nextSibling), $13c40c34b78c8ee2$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$13c40c34b78c8ee2$var$S(g[h], g[++h], g[++h]);
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $13c40c34b78c8ee2$var$I(i, l, u) : $13c40c34b78c8ee2$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $13c40c34b78c8ee2$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $13c40c34b78c8ee2$var$L(u))) return i;
    }
    return null;
}
function $13c40c34b78c8ee2$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $13c40c34b78c8ee2$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $13c40c34b78c8ee2$var$h({}, a.__s)), $13c40c34b78c8ee2$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $13c40c34b78c8ee2$var$h($13c40c34b78c8ee2$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $13c40c34b78c8ee2$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $13c40c34b78c8ee2$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $13c40c34b78c8ee2$var$N(n, u) {
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $13c40c34b78c8ee2$var$n.call(l.childNodes), a = (y = i.props || $13c40c34b78c8ee2$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($13c40c34b78c8ee2$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $13c40c34b78c8ee2$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $13c40c34b78c8ee2$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $13c40c34b78c8ee2$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $13c40c34b78c8ee2$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $13c40c34b78c8ee2$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $13c40c34b78c8ee2$var$q(n, u, i) {
    var t, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $13c40c34b78c8ee2$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $13c40c34b78c8ee2$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $13c40c34b78c8ee2$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $13c40c34b78c8ee2$var$M(i, u = (!r && t || i).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $13c40c34b78c8ee2$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $13c40c34b78c8ee2$var$N(f, u);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $13c40c34b78c8ee2$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), $13c40c34b78c8ee2$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$s.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$var$t = !1, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$h({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$h({}, u), this.props)), n && $13c40c34b78c8ee2$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$T(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$T(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$r = [], $13c40c34b78c8ee2$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$e = 0;




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = [], $204a33a7557cbbd0$var$e = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b, $204a33a7557cbbd0$var$a = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r, $204a33a7557cbbd0$var$v = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed, $204a33a7557cbbd0$var$l = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c, $204a33a7557cbbd0$var$m = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount;
function $204a33a7557cbbd0$var$d(t, u) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h($204a33a7557cbbd0$var$r, t, $204a33a7557cbbd0$var$o || u), $204a33a7557cbbd0$var$o = 0;
    var i = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $204a33a7557cbbd0$var$c
    }), i.__[t];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$B, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        $204a33a7557cbbd0$var$r.u = !0;
        var f = $204a33a7557cbbd0$var$r.shouldComponentUpdate;
        $204a33a7557cbbd0$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__H.__h.push(o));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__h.push(o));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(t, r) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$b() {
    for(var t; t = $204a33a7557cbbd0$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($204a33a7557cbbd0$var$k), t.__H.__h.forEach($204a33a7557cbbd0$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $204a33a7557cbbd0$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$k), i.__h.forEach($204a33a7557cbbd0$var$w), i.__h = [])), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed = function(t) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(o) && $204a33a7557cbbd0$var$i === (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame || (($204a33a7557cbbd0$var$i = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame) || $204a33a7557cbbd0$var$j)($204a33a7557cbbd0$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $204a33a7557cbbd0$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $204a33a7557cbbd0$var$c;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($204a33a7557cbbd0$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(t, r);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount = function(t) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $204a33a7557cbbd0$var$g = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$g && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$k(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$w(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $e21355414fd2bd2a$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $e21355414fd2bd2a$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $e21355414fd2bd2a$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $e21355414fd2bd2a$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $e21355414fd2bd2a$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $e21355414fd2bd2a$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).isPureReactComponent = !0, $e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $e21355414fd2bd2a$var$C(this.props, n) || $e21355414fd2bd2a$var$C(this.state, t);
};
var $e21355414fd2bd2a$var$x = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $e21355414fd2bd2a$var$x && $e21355414fd2bd2a$var$x(n);
};
var $e21355414fd2bd2a$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $e21355414fd2bd2a$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $e21355414fd2bd2a$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $e21355414fd2bd2a$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $e21355414fd2bd2a$var$A = function(n, t) {
    return null == n ? null : (0, $13c40c34b78c8ee2$export$47e4c5b300681277)((0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n).map(t));
}, $e21355414fd2bd2a$export$dca3b0875bd9a954 = {
    map: $e21355414fd2bd2a$var$A,
    forEach: $e21355414fd2bd2a$var$A,
    count: function(n) {
        return n ? (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $13c40c34b78c8ee2$export$47e4c5b300681277)
}, $e21355414fd2bd2a$var$T = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $e21355414fd2bd2a$var$T(n, t, e, r);
};
var $e21355414fd2bd2a$var$I = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount;
function $e21355414fd2bd2a$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $e21355414fd2bd2a$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$L(n, t, e);
    })), n;
}
function $e21355414fd2bd2a$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $e21355414fd2bd2a$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $e21355414fd2bd2a$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $e21355414fd2bd2a$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $e21355414fd2bd2a$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $e21355414fd2bd2a$var$I && $e21355414fd2bd2a$var$I(n);
}, ($e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $e21355414fd2bd2a$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $e21355414fd2bd2a$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $e21355414fd2bd2a$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__h = null), [
        (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $e21355414fd2bd2a$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $e21355414fd2bd2a$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $e21355414fd2bd2a$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e21355414fd2bd2a$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $e21355414fd2bd2a$export$d39a5bbd09211389(n, e) {
    var r = (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e21355414fd2bd2a$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($e21355414fd2bd2a$export$998bcd577473dd93.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $e21355414fd2bd2a$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $e21355414fd2bd2a$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidUpdate = $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $e21355414fd2bd2a$var$W(n, e, t);
    });
};
var $e21355414fd2bd2a$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $e21355414fd2bd2a$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $e21355414fd2bd2a$var$H = "undefined" != typeof document, $e21355414fd2bd2a$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $e21355414fd2bd2a$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $e21355414fd2bd2a$export$fa8d919ba61d84db(n, t, e) {
    return (0, $13c40c34b78c8ee2$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $13c40c34b78c8ee2$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $13c40c34b78c8ee2$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $e21355414fd2bd2a$var$G = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).event;
function $e21355414fd2bd2a$var$J() {}
function $e21355414fd2bd2a$var$K() {
    return this.cancelBubble;
}
function $e21355414fd2bd2a$var$Q() {
    return this.defaultPrevented;
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).event = function(n) {
    return $e21355414fd2bd2a$var$G && (n = $e21355414fd2bd2a$var$G(n)), n.persist = $e21355414fd2bd2a$var$J, n.isPropagationStopped = $e21355414fd2bd2a$var$K, n.isDefaultPrevented = $e21355414fd2bd2a$var$Q, n.nativeEvent = n;
};
var $e21355414fd2bd2a$var$X, $e21355414fd2bd2a$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $e21355414fd2bd2a$var$tn = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $e21355414fd2bd2a$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$e21355414fd2bd2a$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $e21355414fd2bd2a$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($e21355414fd2bd2a$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $e21355414fd2bd2a$var$nn));
    }
    n.$$typeof = $e21355414fd2bd2a$var$z, $e21355414fd2bd2a$var$tn && $e21355414fd2bd2a$var$tn(n);
};
var $e21355414fd2bd2a$var$en = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r = function(n) {
    $e21355414fd2bd2a$var$en && $e21355414fd2bd2a$var$en(n), $e21355414fd2bd2a$var$X = n.__c;
};
var $e21355414fd2bd2a$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $e21355414fd2bd2a$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $e21355414fd2bd2a$export$83d89fbfd8236492 = "17.0.2";
function $e21355414fd2bd2a$export$d38cd72104c1f0e9(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d).bind(null, n);
}
function $e21355414fd2bd2a$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $e21355414fd2bd2a$var$z;
}
function $e21355414fd2bd2a$export$e530037191fcd5d7(n) {
    return $e21355414fd2bd2a$export$a8257692ac88316c(n) ? (0, $13c40c34b78c8ee2$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $e21355414fd2bd2a$export$502457920280e6be(n) {
    return !!n.__k && ((0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, n), !0);
}
function $e21355414fd2bd2a$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $e21355414fd2bd2a$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$5f8d39834fd61797 = (0, $13c40c34b78c8ee2$export$ffb0004e005737fa);
function $e21355414fd2bd2a$export$7568632d0d33d16d(n) {
    n();
}
function $e21355414fd2bd2a$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $e21355414fd2bd2a$export$7b286972b8d8ccbf() {
    return [
        !1,
        $e21355414fd2bd2a$export$7568632d0d33d16d
    ];
}
var $e21355414fd2bd2a$export$aaabe4eda9ed9969 = (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c);
function $e21355414fd2bd2a$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $e21355414fd2bd2a$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(function() {
        return $e21355414fd2bd2a$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $e21355414fd2bd2a$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $e21355414fd2bd2a$export$2e2bcd8739ae039 = {
    useState: (0, $204a33a7557cbbd0$export$60241385465d0a34),
    useId: (0, $204a33a7557cbbd0$export$f680877a34711e37),
    useReducer: (0, $204a33a7557cbbd0$export$13e3392192263954),
    useEffect: (0, $204a33a7557cbbd0$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c),
    useInsertionEffect: $e21355414fd2bd2a$export$aaabe4eda9ed9969,
    useTransition: $e21355414fd2bd2a$export$7b286972b8d8ccbf,
    useDeferredValue: $e21355414fd2bd2a$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $e21355414fd2bd2a$export$306c0aa65ff9ec16,
    startTransition: $e21355414fd2bd2a$export$7568632d0d33d16d,
    useRef: (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $204a33a7557cbbd0$export$d5a552a76deda3c2),
    useMemo: (0, $204a33a7557cbbd0$export$1538c33de8887b59),
    useCallback: (0, $204a33a7557cbbd0$export$35808ee640e87ca7),
    useContext: (0, $204a33a7557cbbd0$export$fae74005e78b1a27),
    useDebugValue: (0, $204a33a7557cbbd0$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $e21355414fd2bd2a$export$dca3b0875bd9a954,
    render: $e21355414fd2bd2a$export$b3890eb0ae9dca99,
    hydrate: $e21355414fd2bd2a$export$fa8d919ba61d84db,
    unmountComponentAtNode: $e21355414fd2bd2a$export$502457920280e6be,
    createPortal: $e21355414fd2bd2a$export$d39a5bbd09211389,
    createElement: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d),
    createContext: (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109),
    createFactory: $e21355414fd2bd2a$export$d38cd72104c1f0e9,
    cloneElement: $e21355414fd2bd2a$export$e530037191fcd5d7,
    createRef: (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43),
    Fragment: (0, $13c40c34b78c8ee2$export$ffb0004e005737fa),
    isValidElement: $e21355414fd2bd2a$export$a8257692ac88316c,
    findDOMNode: $e21355414fd2bd2a$export$466bfc07425424d5,
    Component: (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8),
    PureComponent: $e21355414fd2bd2a$export$221d75b3f55bb0bd,
    memo: $e21355414fd2bd2a$export$7c73462e0d25e514,
    forwardRef: $e21355414fd2bd2a$export$257a8862b851cb5b,
    flushSync: $e21355414fd2bd2a$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $e21355414fd2bd2a$export$c78a37762a8d58e1,
    StrictMode: $e21355414fd2bd2a$export$5f8d39834fd61797,
    Suspense: $e21355414fd2bd2a$export$74bf444e3cd11ea5,
    SuspenseList: $e21355414fd2bd2a$export$998bcd577473dd93,
    lazy: $e21355414fd2bd2a$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $e21355414fd2bd2a$export$ae55be85d98224ed
};


const $6e5ed45f0fbbb6e2$var$styleTexts = [];
const $6e5ed45f0fbbb6e2$var$styleEls = new Map();
function $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75(styleText) {
    $6e5ed45f0fbbb6e2$var$styleTexts.push(styleText);
    $6e5ed45f0fbbb6e2$var$styleEls.forEach((styleEl)=>{
        $6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText);
    });
}
function $6e5ed45f0fbbb6e2$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $6e5ed45f0fbbb6e2$var$registerStylesRoot(el.getRootNode());
}
function $6e5ed45f0fbbb6e2$var$registerStylesRoot(rootNode) {
    let styleEl = $6e5ed45f0fbbb6e2$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            const nonce = $6e5ed45f0fbbb6e2$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $6e5ed45f0fbbb6e2$var$styleEls.set(rootNode, styleEl);
        $6e5ed45f0fbbb6e2$var$hydrateStylesRoot(styleEl);
    }
}
function $6e5ed45f0fbbb6e2$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $6e5ed45f0fbbb6e2$var$styleTexts)$6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText);
}
function $6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $6e5ed45f0fbbb6e2$var$queriedNonceValue;
function $6e5ed45f0fbbb6e2$var$getNonceValue() {
    if ($6e5ed45f0fbbb6e2$var$queriedNonceValue === undefined) $6e5ed45f0fbbb6e2$var$queriedNonceValue = $6e5ed45f0fbbb6e2$var$queryNonceValue();
    return $6e5ed45f0fbbb6e2$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $6e5ed45f0fbbb6e2$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    const elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') $6e5ed45f0fbbb6e2$var$registerStylesRoot(document);
var $6e5ed45f0fbbb6e2$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
$6e5ed45f0fbbb6e2$export$e9316ff9106cdb75($6e5ed45f0fbbb6e2$var$css_248z);
class $6e5ed45f0fbbb6e2$export$96f57966bedc81b4 {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = '') {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = '', force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function $6e5ed45f0fbbb6e2$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($6e5ed45f0fbbb6e2$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $6e5ed45f0fbbb6e2$export$c03999cb2f36933f(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $6e5ed45f0fbbb6e2$export$23ebac1979863676(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $6e5ed45f0fbbb6e2$export$91477dc880baac21(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $6e5ed45f0fbbb6e2$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $6e5ed45f0fbbb6e2$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $6e5ed45f0fbbb6e2$export$faec65b429be379(el, props) {
    for(let propName in props)$6e5ed45f0fbbb6e2$export$2219238a014317b0(el, propName, props[propName]);
}
function $6e5ed45f0fbbb6e2$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && $6e5ed45f0fbbb6e2$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $6e5ed45f0fbbb6e2$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $6e5ed45f0fbbb6e2$var$guid$1 = 0;
function $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6() {
    $6e5ed45f0fbbb6e2$var$guid$1 += 1;
    return 'fc-dom-' + $6e5ed45f0fbbb6e2$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    let attachedHandler = $6e5ed45f0fbbb6e2$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $6e5ed45f0fbbb6e2$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $6e5ed45f0fbbb6e2$var$transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function $6e5ed45f0fbbb6e2$export$8c78c7c36408ea29(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $6e5ed45f0fbbb6e2$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $6e5ed45f0fbbb6e2$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs(handler));
}
function $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $6e5ed45f0fbbb6e2$var$guidNumber = 0;
function $6e5ed45f0fbbb6e2$export$39b482c5e57630a8() {
    $6e5ed45f0fbbb6e2$var$guidNumber += 1;
    return String($6e5ed45f0fbbb6e2$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $6e5ed45f0fbbb6e2$export$d66dc83d8cfc8dd() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function $6e5ed45f0fbbb6e2$export$1fbe638ecf81657e() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$8a5498727ef6be21(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$d24c54395ce0c509(el) {
    el.addEventListener('contextmenu', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$6554612db691658e(el) {
    el.removeEventListener('contextmenu', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$1a82df3d29112e01(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function $6e5ed45f0fbbb6e2$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $6e5ed45f0fbbb6e2$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $6e5ed45f0fbbb6e2$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $6e5ed45f0fbbb6e2$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $6e5ed45f0fbbb6e2$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$21579262ef46735b(val, len) {
    let s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter(...args);
    if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
const $6e5ed45f0fbbb6e2$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(input, unit) {
    if (typeof input === 'string') return $6e5ed45f0fbbb6e2$var$parseString(input);
    if (typeof input === 'object' && input) return $6e5ed45f0fbbb6e2$var$parseObject(input);
    if (typeof input === 'number') return $6e5ed45f0fbbb6e2$var$parseObject({
        [unit || 'milliseconds']: input
    });
    return null;
}
function $6e5ed45f0fbbb6e2$var$parseString(s) {
    let m = $6e5ed45f0fbbb6e2$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $6e5ed45f0fbbb6e2$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $6e5ed45f0fbbb6e2$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $6e5ed45f0fbbb6e2$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $6e5ed45f0fbbb6e2$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $6e5ed45f0fbbb6e2$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $6e5ed45f0fbbb6e2$var$asRoughYears(dur) {
    return $6e5ed45f0fbbb6e2$var$asRoughDays(dur) / 365;
}
function $6e5ed45f0fbbb6e2$var$asRoughMonths(dur) {
    return $6e5ed45f0fbbb6e2$var$asRoughDays(dur) / 30;
}
function $6e5ed45f0fbbb6e2$var$asRoughDays(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 864e5;
}
function $6e5ed45f0fbbb6e2$export$847533e5bf524f5f(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 60000;
}
function $6e5ed45f0fbbb6e2$export$b169257caa88022a(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 1000;
}
function $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $6e5ed45f0fbbb6e2$export$479ac0420f53ed26(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS.length; i += 1){
        let unit = $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function $6e5ed45f0fbbb6e2$export$3d12bd131bb975d1(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $6e5ed45f0fbbb6e2$var$DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function $6e5ed45f0fbbb6e2$export$151db275011178c4(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
function $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[2] += n;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
function $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[6] += n;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $6e5ed45f0fbbb6e2$export$136fd86de524d3c2(m0, m1) {
    return $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $6e5ed45f0fbbb6e2$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $6e5ed45f0fbbb6e2$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $6e5ed45f0fbbb6e2$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $6e5ed45f0fbbb6e2$export$62d08d6fa708df47(m0, m1) {
    let m0day = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m0);
    let m1day = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $6e5ed45f0fbbb6e2$export$31e67cf12fc9668(m0, m1) {
    let d = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1) {
    if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1)) return Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfHour(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfMinute(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfSecond(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $6e5ed45f0fbbb6e2$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        year,
        0,
        1 + $6e5ed45f0fbbb6e2$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(marker);
    let days = Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $6e5ed45f0fbbb6e2$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $6e5ed45f0fbbb6e2$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $6e5ed45f0fbbb6e2$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $6e5ed45f0fbbb6e2$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $6e5ed45f0fbbb6e2$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $6e5ed45f0fbbb6e2$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $6e5ed45f0fbbb6e2$export$f438b12253c2b499(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $6e5ed45f0fbbb6e2$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function $6e5ed45f0fbbb6e2$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $6e5ed45f0fbbb6e2$export$4e222d082f82ee97(marker) {
    return $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCHours(), 2) + ':' + $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ':' + $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? '-' : '+';
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $6e5ed45f0fbbb6e2$export$21579262ef46735b(hours, 2)}:${$6e5ed45f0fbbb6e2$export$21579262ef46735b(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$6e5ed45f0fbbb6e2$export$21579262ef46735b(mins, 2)}` : ''}`;
}
function $6e5ed45f0fbbb6e2$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $6e5ed45f0fbbb6e2$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $6e5ed45f0fbbb6e2$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $6e5ed45f0fbbb6e2$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
const $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $6e5ed45f0fbbb6e2$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $6e5ed45f0fbbb6e2$var$COMMA_RE = /,/g; // we need re for globalness
const $6e5ed45f0fbbb6e2$var$MULTI_SPACE_RE = /\s+/g;
const $6e5ed45f0fbbb6e2$var$LTR_RE = /\u200e/g; // control character
const $6e5ed45f0fbbb6e2$var$UTC_RE = /UTC|GMT/;
class $6e5ed45f0fbbb6e2$var$NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(let name in formatSettings)if (name in $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            const severity = $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $6e5ed45f0fbbb6e2$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $6e5ed45f0fbbb6e2$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $6e5ed45f0fbbb6e2$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $6e5ed45f0fbbb6e2$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getSmallestUnit() {
        switch(this.smallestUnitNum){
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    }
}
function $6e5ed45f0fbbb6e2$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>$6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$6e5ed45f0fbbb6e2$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $6e5ed45f0fbbb6e2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $6e5ed45f0fbbb6e2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $6e5ed45f0fbbb6e2$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $6e5ed45f0fbbb6e2$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $6e5ed45f0fbbb6e2$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $6e5ed45f0fbbb6e2$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($6e5ed45f0fbbb6e2$var$LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = $6e5ed45f0fbbb6e2$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($6e5ed45f0fbbb6e2$var$COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === 'short') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($6e5ed45f0fbbb6e2$var$MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function $6e5ed45f0fbbb6e2$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($6e5ed45f0fbbb6e2$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $6e5ed45f0fbbb6e2$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $6e5ed45f0fbbb6e2$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($6e5ed45f0fbbb6e2$var$timeAsMs(d0) !== $6e5ed45f0fbbb6e2$var$timeAsMs(d1)) return 1;
    return 0;
}
function $6e5ed45f0fbbb6e2$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $6e5ed45f0fbbb6e2$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $6e5ed45f0fbbb6e2$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $6e5ed45f0fbbb6e2$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $6e5ed45f0fbbb6e2$var$CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class $6e5ed45f0fbbb6e2$var$FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func($6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(input) {
    if (typeof input === 'object' && input) return new $6e5ed45f0fbbb6e2$var$NativeFormatter(input);
    if (typeof input === 'string') return new $6e5ed45f0fbbb6e2$var$CmdFormatter(input);
    if (typeof input === 'function') return new $6e5ed45f0fbbb6e2$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $6e5ed45f0fbbb6e2$export$61196ced6d74a310 = {
    navLinkDayClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    duration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    bootstrapFontAwesome: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonIcons: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customButtons: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    defaultTimedEventDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    nextDayThreshold: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    scrollTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    slotMaxTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    dayPopoverFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    slotDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    snapDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    headerToolbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    footerToolbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    dayHeaderClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorSnap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    locale: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventOrder: $6e5ed45f0fbbb6e2$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    contentHeight: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialDate: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    now: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewHeight: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventConstraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventAllow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectConstraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectOverlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectAllow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    hiddenDays: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    visibleRange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    titleFormat: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    navLinkHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $6e5ed45f0fbbb6e2$export$f1e1789686576879 = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    },
    nowIndicatorSnap: 'auto'
};
// calendar listeners
// ------------------
const $6e5ed45f0fbbb6e2$export$3a1a48c8f6ef640e = {
    datesSet: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventsSet: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventAdd: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventChange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventRemove: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    windowResize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    select: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    unselect: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    loading: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _beforeprint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _afterprint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _noEventResize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _resize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $6e5ed45f0fbbb6e2$export$a07804094c3ecf2d = {
    buttonText: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonHints: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    views: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    plugins: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialEvents: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    events: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventSources: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
const $6e5ed45f0fbbb6e2$export$c4ce752e73470fba = {
    headerToolbar: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    footerToolbar: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonText: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonHints: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonIcons: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    dateIncrement: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    plugins: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    events: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    eventSources: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    ['resources']: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual
};
function $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) return $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $6e5ed45f0fbbb6e2$export$56c0d5a1e737357d = {
    type: String,
    component: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    content: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    didMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    willUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$3466f893ebf79586(optionSets) {
    return $6e5ed45f0fbbb6e2$export$953cecd6e717a553(optionSets, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba);
}
function $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
const { hasOwnProperty: $6e5ed45f0fbbb6e2$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $6e5ed45f0fbbb6e2$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $6e5ed45f0fbbb6e2$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $6e5ed45f0fbbb6e2$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $6e5ed45f0fbbb6e2$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $6e5ed45f0fbbb6e2$var$HANDLER_RE = /^on[A-Z]/;
function $6e5ed45f0fbbb6e2$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $6e5ed45f0fbbb6e2$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$6e5ed45f0fbbb6e2$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(let key in newProps){
        if (key in oldProps && $6e5ed45f0fbbb6e2$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $6e5ed45f0fbbb6e2$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $6e5ed45f0fbbb6e2$export$a05254e7c3aeba6e(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let $6e5ed45f0fbbb6e2$var$calendarSystemClassMap = {};
function $6e5ed45f0fbbb6e2$var$registerCalendarSystem(name, theClass) {
    $6e5ed45f0fbbb6e2$var$calendarSystemClassMap[name] = theClass;
}
function $6e5ed45f0fbbb6e2$var$createCalendarSystem(name) {
    return new $6e5ed45f0fbbb6e2$var$calendarSystemClassMap[name]();
}
class $6e5ed45f0fbbb6e2$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $6e5ed45f0fbbb6e2$var$dateToUtcArray(marker);
    }
}
$6e5ed45f0fbbb6e2$var$registerCalendarSystem('gregory', $6e5ed45f0fbbb6e2$var$GregorianCalendarSystem);
const $6e5ed45f0fbbb6e2$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $6e5ed45f0fbbb6e2$export$26a0a7676ca7aa04(str) {
    let m = $6e5ed45f0fbbb6e2$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($6e5ed45f0fbbb6e2$export$5521614468b862fb(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $6e5ed45f0fbbb6e2$export$3722cfe417b6ed86 {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $6e5ed45f0fbbb6e2$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate($6e5ed45f0fbbb6e2$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === 'string') return this.parse(input);
        let marker = null;
        if (typeof input === 'number') marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $6e5ed45f0fbbb6e2$var$arrayToUtcDate(input);
        if (marker === null || !$6e5ed45f0fbbb6e2$export$5521614468b862fb(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $6e5ed45f0fbbb6e2$export$26a0a7676ca7aa04(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: 'year',
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: 'month',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$export$31e67cf12fc9668(m0, m1);
        if (n !== null) return {
            unit: 'week',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: 'day',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffHours(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'hour',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffMinutes(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'minute',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffSeconds(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'second',
            value: n
        };
        return {
            unit: 'millisecond',
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === 'year') return this.startOfYear(m);
        if (unit === 'month') return this.startOfMonth(m);
        if (unit === 'week') return this.startOfWeek(m);
        if (unit === 'day') return $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m);
        if (unit === 'hour') return $6e5ed45f0fbbb6e2$var$startOfHour(m);
        if (unit === 'minute') return $6e5ed45f0fbbb6e2$var$startOfMinute(m);
        if (unit === 'second') return $6e5ed45f0fbbb6e2$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $6e5ed45f0fbbb6e2$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $6e5ed45f0fbbb6e2$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === 'local') return $6e5ed45f0fbbb6e2$var$arrayToUtcDate($6e5ed45f0fbbb6e2$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === 'local') return -$6e5ed45f0fbbb6e2$var$arrayToLocalDate($6e5ed45f0fbbb6e2$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === 'UTC') return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($6e5ed45f0fbbb6e2$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === 'local') return $6e5ed45f0fbbb6e2$var$arrayToLocalDate($6e5ed45f0fbbb6e2$var$dateToUtcArray(m));
        if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($6e5ed45f0fbbb6e2$var$dateToUtcArray(m)) * 60000);
    }
}
class $6e5ed45f0fbbb6e2$export$971d5caa766a69d7 {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || '';
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return '';
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return '';
    }
}
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.classes = {};
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.iconClasses = {};
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.baseIconClass = '';
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $6e5ed45f0fbbb6e2$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering = execCallbackSync;
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99($13c40c34b78c8ee2$export$c8a8987d4410bf2d($6e5ed45f0fbbb6e2$var$FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering = oldDebounceRendering;
}
class $6e5ed45f0fbbb6e2$var$FakeComponent extends $13c40c34b78c8ee2$export$16fa2f45be04daa8 {
    render() {
        return $13c40c34b78c8ee2$export$c8a8987d4410bf2d('div', {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57(defaultValue) {
    let ContextType = $13c40c34b78c8ee2$export$fd42f52fd3ae1109(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $6e5ed45f0fbbb6e2$export$49e6ee724f7f1ace {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const $6e5ed45f0fbbb6e2$export$e7c866399fa523f5 = $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57({}); // for Components
function $6e5ed45f0fbbb6e2$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder (execFunc) {
            return new $6e5ed45f0fbbb6e2$export$49e6ee724f7f1ace(execFunc, emitter, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    // debug: boolean
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality /*, this.debug */ ) || !$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality /*, this.debug */ );
        // if (this.debug && shouldUpdate) {
        //   console.log('shouldUpdate!')
        // }
        return shouldUpdate;
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.addPropsEquality = $6e5ed45f0fbbb6e2$var$addPropsEquality;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.addStateEquality = $6e5ed45f0fbbb6e2$var$addStateEquality;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.prototype.propEquality = {};
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.prototype.stateEquality = {};
class $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 extends $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea {
}
$6e5ed45f0fbbb6e2$export$ef35774e6d314e91.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
function $6e5ed45f0fbbb6e2$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $6e5ed45f0fbbb6e2$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class $6e5ed45f0fbbb6e2$var$ContentInjector extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.id = $6e5ed45f0fbbb6e2$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options: options } = this.context;
            const { generatorName: generatorName } = this.props;
            if (!options.customRenderingReplaces || !$6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === 'object'; // non-null
                if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, $13c40c34b78c8ee2$export$a8257692ac88316c)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($6e5ed45f0fbbb6e2$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($6e5ed45f0fbbb6e2$export$9f4f30ee63539e24);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
$6e5ed45f0fbbb6e2$var$ContentInjector.addPropsEquality({
    elClasses: $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef,
    elStyle: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca,
    elAttrs: $6e5ed45f0fbbb6e2$var$isNonHandlerPropsEqual,
    renderProps: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $6e5ed45f0fbbb6e2$var$isTruthy(val) {
    return Boolean(val);
}
const $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de = $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57(0);
class $6e5ed45f0fbbb6e2$export$e7094788287c5e9b extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.InnerContent = $6e5ed45f0fbbb6e2$var$InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props: props } = this;
        const generatedClassNames = $6e5ed45f0fbbb6e2$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || 'div',
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
$6e5ed45f0fbbb6e2$export$e7094788287c5e9b.contextType = $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de;
function $6e5ed45f0fbbb6e2$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $6e5ed45f0fbbb6e2$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
class $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }, ()=>props.children);
    }
}
function $6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        'fc-view'
    ];
}
function $6e5ed45f0fbbb6e2$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $6e5ed45f0fbbb6e2$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($6e5ed45f0fbbb6e2$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $6e5ed45f0fbbb6e2$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $6e5ed45f0fbbb6e2$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $6e5ed45f0fbbb6e2$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $6e5ed45f0fbbb6e2$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $6e5ed45f0fbbb6e2$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $6e5ed45f0fbbb6e2$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    let start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.start);
    let end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $6e5ed45f0fbbb6e2$export$92108d983e8ee699(timedRange, nextDayThreshold = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(nextDayThreshold)) endDay = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $6e5ed45f0fbbb6e2$export$9fa96a7d116ea3ce(range) {
    let visibleRange = $6e5ed45f0fbbb6e2$export$92108d983e8ee699(range);
    return $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
    return $6e5ed45f0fbbb6e2$export$62d08d6fa708df47(date0, date1); // returns a duration
}
class $6e5ed45f0fbbb6e2$export$db202ddc8be9136 {
    constructor(props){
        this.props = props;
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $6e5ed45f0fbbb6e2$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $6e5ed45f0fbbb6e2$export$c18d01048907ea92(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($6e5ed45f0fbbb6e2$var$asRoughDays(slotMinTime) < 0) {
                start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($6e5ed45f0fbbb6e2$var$asRoughDays(slotMaxTime) > 1) {
                end = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(end); // necessary?
                end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dateIncrement) < $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(duration)) dateAlignment = $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($6e5ed45f0fbbb6e2$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $6e5ed45f0fbbb6e2$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $6e5ed45f0fbbb6e2$export$92108d983e8ee699(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(date, inc);
        return date;
    }
}
function $6e5ed45f0fbbb6e2$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $6e5ed45f0fbbb6e2$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $6e5ed45f0fbbb6e2$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $6e5ed45f0fbbb6e2$export$995eb9fca571757(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $6e5ed45f0fbbb6e2$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($6e5ed45f0fbbb6e2$export$9e5f44173e64f162);
    return markers;
}
const $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS = {
    start: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    end: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    date: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $6e5ed45f0fbbb6e2$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS), {
    extendedProps: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
});
function $6e5ed45f0fbbb6e2$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$3b513254972cfc9c(raw, context, refiners);
    let defaultAllDay = $6e5ed45f0fbbb6e2$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $6e5ed45f0fbbb6e2$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $6e5ed45f0fbbb6e2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $6e5ed45f0fbbb6e2$export$995eb9fca571757(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$3b513254972cfc9c(raw, context, refiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context)) {
    return $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, refiners);
}
function $6e5ed45f0fbbb6e2$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $6e5ed45f0fbbb6e2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $6e5ed45f0fbbb6e2$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $6e5ed45f0fbbb6e2$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
    let eventRefiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $6e5ed45f0fbbb6e2$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple, eventStore);
    }
    return eventStore;
}
function $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple, eventStore = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $6e5ed45f0fbbb6e2$export$667d3bf0c5f83305(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (lookDef)=>$6e5ed45f0fbbb6e2$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
}
function $6e5ed45f0fbbb6e2$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $6e5ed45f0fbbb6e2$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $6e5ed45f0fbbb6e2$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $6e5ed45f0fbbb6e2$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === 'object' && input) return $6e5ed45f0fbbb6e2$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $6e5ed45f0fbbb6e2$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    overlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    className: $6e5ed45f0fbbb6e2$export$f96d196f7728bb5,
    classNames: $6e5ed45f0fbbb6e2$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context) {
    let constraint = $6e5ed45f0fbbb6e2$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($6e5ed45f0fbbb6e2$var$combineTwoEventUis, $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_UI);
}
function $6e5ed45f0fbbb6e2$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $6e5ed45f0fbbb6e2$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    failure: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
function $6e5ed45f0fbbb6e2$export$ffb5f4729a158638(raw, context, refiners = $6e5ed45f0fbbb6e2$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === 'object' && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(rawObj, refiners);
        let metaRes = $6e5ed45f0fbbb6e2$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $6e5ed45f0fbbb6e2$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return $6e5ed45f0fbbb6e2$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return $6e5ed45f0fbbb6e2$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return $6e5ed45f0fbbb6e2$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $6e5ed45f0fbbb6e2$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return $6e5ed45f0fbbb6e2$var$excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return $6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case 'REMOVE_ALL_EVENTS':
            return $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $6e5ed45f0fbbb6e2$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $6e5ed45f0fbbb6e2$var$expandRecurring(subset, fetchRange, context);
        return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e($6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $6e5ed45f0fbbb6e2$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $6e5ed45f0fbbb6e2$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $6e5ed45f0fbbb6e2$var$expandRecurring(newEventStore, activeRange, context);
}
function $6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $6e5ed45f0fbbb6e2$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $6e5ed45f0fbbb6e2$var$expandRecurring(subset, expandRange, context);
    return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $6e5ed45f0fbbb6e2$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $6e5ed45f0fbbb6e2$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $6e5ed45f0fbbb6e2$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
class $6e5ed45f0fbbb6e2$export$d66501df72047452 {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $6e5ed45f0fbbb6e2$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $6e5ed45f0fbbb6e2$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function $6e5ed45f0fbbb6e2$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $6e5ed45f0fbbb6e2$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const $6e5ed45f0fbbb6e2$var$DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function $6e5ed45f0fbbb6e2$export$3a6d5c9ae78a2c08(input, context) {
    return $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$refineInputs(input), null, context);
}
function $6e5ed45f0fbbb6e2$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function $6e5ed45f0fbbb6e2$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $6e5ed45f0fbbb6e2$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $6e5ed45f0fbbb6e2$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $6e5ed45f0fbbb6e2$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $6e5ed45f0fbbb6e2$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $6e5ed45f0fbbb6e2$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $6e5ed45f0fbbb6e2$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $6e5ed45f0fbbb6e2$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(copy.range.start),
        end: $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $6e5ed45f0fbbb6e2$var$EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class $6e5ed45f0fbbb6e2$export$71511d61b312f219 {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
        else if (name === 'id') {
            val = $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS) {
            val = $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS) {
            let ui = $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS[name](val);
            if (name === 'color') ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === 'editable') ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(instanceRange);
            let startDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                if ($6e5ed45f0fbbb6e2$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $6e5ed45f0fbbb6e2$export$667d3bf0c5f83305(eventStore, instance.instanceId);
            let eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: []
                }
            };
            relevantEvents = $6e5ed45f0fbbb6e2$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents
            });
            context.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $6e5ed45f0fbbb6e2$var$eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return '';
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return '';
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || 'auto';
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== 'auto') res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function $6e5ed45f0fbbb6e2$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $6e5ed45f0fbbb6e2$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $6e5ed45f0fbbb6e2$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        let slicedRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $6e5ed45f0fbbb6e2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $6e5ed45f0fbbb6e2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $6e5ed45f0fbbb6e2$export$45aabb5431c2d04f(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function $6e5ed45f0fbbb6e2$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $6e5ed45f0fbbb6e2$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $6e5ed45f0fbbb6e2$var$compileEventUis(eventDefs, eventUiBases) {
    return $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventDefs, (eventDef)=>$6e5ed45f0fbbb6e2$var$compileEventUi(eventDef, eventUiBases));
}
function $6e5ed45f0fbbb6e2$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(uis);
}
function $6e5ed45f0fbbb6e2$export$a91cd623adc48128(segs, eventOrderSpecs) {
    let objs = segs.map($6e5ed45f0fbbb6e2$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$6e5ed45f0fbbb6e2$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $6e5ed45f0fbbb6e2$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $6e5ed45f0fbbb6e2$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $6e5ed45f0fbbb6e2$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $6e5ed45f0fbbb6e2$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $6e5ed45f0fbbb6e2$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(wholeEventStart).valueOf() === $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162($6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $6e5ed45f0fbbb6e2$export$9e5f44173e64f162($6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function $6e5ed45f0fbbb6e2$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $6e5ed45f0fbbb6e2$var$getEventClassNames(props) {
    let classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $6e5ed45f0fbbb6e2$export$6dabbe08653f866f(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $6e5ed45f0fbbb6e2$var$STANDARD_PROPS = {
    start: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    end: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $6e5ed45f0fbbb6e2$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $6e5ed45f0fbbb6e2$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $6e5ed45f0fbbb6e2$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, $6e5ed45f0fbbb6e2$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $6e5ed45f0fbbb6e2$export$7f557e5eb95176c2(span0, span1) {
    return $6e5ed45f0fbbb6e2$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $6e5ed45f0fbbb6e2$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $6e5ed45f0fbbb6e2$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $6e5ed45f0fbbb6e2$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $6e5ed45f0fbbb6e2$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $6e5ed45f0fbbb6e2$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $6e5ed45f0fbbb6e2$export$3b513254972cfc9c({
        editable: false
    }, context);
    let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $6e5ed45f0fbbb6e2$var$compileEventUi(def, eventUiBases),
        instance: $6e5ed45f0fbbb6e2$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $6e5ed45f0fbbb6e2$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
class $6e5ed45f0fbbb6e2$export$f787f51d84a910ad extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $6e5ed45f0fbbb6e2$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $6e5ed45f0fbbb6e2$export$f787f51d84a910ad('Failure parsing JSON', fetchRes);
        });
        else throw new $6e5ed45f0fbbb6e2$export$f787f51d84a910ad('Request failed', fetchRes);
    });
}
let $6e5ed45f0fbbb6e2$var$canVGrowWithinCell;
function $6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9() {
    if ($6e5ed45f0fbbb6e2$var$canVGrowWithinCell == null) $6e5ed45f0fbbb6e2$var$canVGrowWithinCell = $6e5ed45f0fbbb6e2$var$computeCanVGrowWithinCell();
    return $6e5ed45f0fbbb6e2$var$canVGrowWithinCell;
}
function $6e5ed45f0fbbb6e2$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    let el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    let div = el.querySelector('div');
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class $6e5ed45f0fbbb6e2$export$a9c996f45e5784d0 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            $6e5ed45f0fbbb6e2$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            $6e5ed45f0fbbb6e2$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        let height = !isHeightAuto && options.height != null ? options.height : '';
        let classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            `fc-direction-${options.direction}`,
            props.theme.getClass('root')
        ];
        if (!$6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9()) classNames.push('fc-liquid-hack');
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    }
}
class $6e5ed45f0fbbb6e2$export$78acf4525d8a74c4 {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function $6e5ed45f0fbbb6e2$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $6e5ed45f0fbbb6e2$export$381353cf1dd55255(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $6e5ed45f0fbbb6e2$export$a8550f7dbe79f93a = {};
class $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.handleRefresh = ()=>{
            let timing = this.computeTiming();
            if (timing.state.nowDate.valueOf() !== this.state.nowDate.valueOf()) this.setState(timing.state);
            this.clearTimeout();
            this.setTimeout(timing.waitMs);
        };
        this.handleVisibilityChange = ()=>{
            if (!document.hidden) this.handleRefresh();
        };
        this.state = this.computeTiming().state;
    }
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
        this.context.nowManager.addResetListener(this.handleRefresh);
        // fired tab becomes visible after being hidden
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
        this.context.nowManager.removeResetListener(this.handleRefresh);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = context.nowManager.getDateMarker();
        let { nowIndicatorSnap: nowIndicatorSnap } = context.options;
        if (nowIndicatorSnap === 'auto') nowIndicatorSnap = // large unit?
        /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
        (props.unitValue || 1) === 1;
        let nowDate;
        let waitMs;
        if (nowIndicatorSnap) {
            nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
            let nextUnitStart = context.dateEnv.add(nowDate, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(1, props.unit));
            waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        } else {
            nowDate = unroundedNow;
            waitMs = 60000; // 1 minute
        }
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            state: {
                nowDate: nowDate,
                todayRange: $6e5ed45f0fbbb6e2$var$buildDayRange(nowDate)
            },
            waitMs: waitMs
        };
    }
    setTimeout(waitMs = this.computeTiming().waitMs) {
        // NOTE: timeout could take longer than expected if tab sleeps,
        // which is why we listen to 'visibilitychange'
        this.timeoutId = setTimeout(()=>{
            // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
            // This is why use use same waitMs from computeTiming, so we don't skip an interval while
            // .setState() is executing
            const timing = this.computeTiming();
            this.setState(timing.state, ()=>{
                this.setTimeout(timing.waitMs);
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
$6e5ed45f0fbbb6e2$export$2e2af4578d910ddf.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
function $6e5ed45f0fbbb6e2$var$buildDayRange(date) {
    let start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(date);
    let end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $6e5ed45f0fbbb6e2$export$a93c5207d687da10 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger('_resize', true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType
                    });
                    this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: 'PREV'
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: 'NEXT'
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.nowManager.getDateMarker()
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $6e5ed45f0fbbb6e2$var$parseDateSpan(selectionInput, state.dateEnv, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: 'SELECT_DATES',
                selection: selection
            });
            $6e5ed45f0fbbb6e2$export$cbfbec548517f2b6(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: 'UNSELECT_DATES'
            });
            $6e5ed45f0fbbb6e2$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $6e5ed45f0fbbb6e2$export$71511d61b312f219) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: $6e5ed45f0fbbb6e2$export$317a3d46287192d8({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $6e5ed45f0fbbb6e2$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) [eventSource] = $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $6e5ed45f0fbbb6e2$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: $6e5ed45f0fbbb6e2$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENTS'
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $6e5ed45f0fbbb6e2$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $6e5ed45f0fbbb6e2$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    eventSource
                ]
            });
            return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENT_SOURCES'
        });
    }
    refetchEvents() {
        this.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger('_scrollRequest', {
            time: time
        });
    }
}
function $6e5ed45f0fbbb6e2$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $6e5ed45f0fbbb6e2$export$890c4ad488842ce7(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $6e5ed45f0fbbb6e2$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $6e5ed45f0fbbb6e2$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $6e5ed45f0fbbb6e2$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $6e5ed45f0fbbb6e2$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
class $6e5ed45f0fbbb6e2$export$9d0e2d13d04f7070 {
    constructor(){
        this.getKeysForEventDefs = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function $6e5ed45f0fbbb6e2$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        '': $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $6e5ed45f0fbbb6e2$export$1a8f5705751d8277(meta, theme) {
    let classNames = [
        'fc-day',
        `fc-day-${$6e5ed45f0fbbb6e2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        'fc-slot',
        `fc-slot-${$6e5ed45f0fbbb6e2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
const $6e5ed45f0fbbb6e2$var$DAY_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
const $6e5ed45f0fbbb6e2$var$WEEK_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    week: 'long'
});
function $6e5ed45f0fbbb6e2$export$a17c37559e1db147(context, dateMarker, viewType = 'day', isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $6e5ed45f0fbbb6e2$var$WEEK_FORMAT : $6e5ed45f0fbbb6e2$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
let $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft = null;
function $6e5ed45f0fbbb6e2$export$c7ca7e4bc4f8a16e() {
    if ($6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft === null) $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft = $6e5ed45f0fbbb6e2$var$computeIsRtlScrollbarOnLeft();
    return $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft;
}
function $6e5ed45f0fbbb6e2$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement('div');
    $6e5ed45f0fbbb6e2$export$faec65b429be379(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $6e5ed45f0fbbb6e2$export$9f4f30ee63539e24(outerEl);
    return res;
}
let $6e5ed45f0fbbb6e2$var$_scrollbarWidths;
function $6e5ed45f0fbbb6e2$export$a1edd97dd51cd48d() {
    if (!$6e5ed45f0fbbb6e2$var$_scrollbarWidths) $6e5ed45f0fbbb6e2$var$_scrollbarWidths = $6e5ed45f0fbbb6e2$var$computeScrollbarWidths();
    return $6e5ed45f0fbbb6e2$var$_scrollbarWidths;
}
function $6e5ed45f0fbbb6e2$var$computeScrollbarWidths() {
    let el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    let res = $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $6e5ed45f0fbbb6e2$export$2ec5befb9e6c97d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($6e5ed45f0fbbb6e2$export$c7ca7e4bc4f8a16e() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$d29e374196577086(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $6e5ed45f0fbbb6e2$export$39c1cc7c062529d4(el);
    let edges = $6e5ed45f0fbbb6e2$export$2ec5befb9e6c97d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$39c1cc7c062529d4(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $6e5ed45f0fbbb6e2$var$computeClippedClientRect(el) {
    let clippingParents = $6e5ed45f0fbbb6e2$export$53c86fa97d611818(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $6e5ed45f0fbbb6e2$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $6e5ed45f0fbbb6e2$export$53c86fa97d611818(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8 {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $6e5ed45f0fbbb6e2$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function $6e5ed45f0fbbb6e2$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $6e5ed45f0fbbb6e2$export$7060da4b5db56fb9 extends $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class $6e5ed45f0fbbb6e2$export$c5d1328b37d47994 extends $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.uid = $6e5ed45f0fbbb6e2$export$39b482c5e57630a8();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-event-mirror');
    }
    isValidDateDownEl(el) {
        return !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-event:not(.fc-bg-event)') && !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-more-link') && // a "more.." link
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, 'a[data-navlink]') && // a clickable nav link
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-popover'); // hack
    }
}
class $6e5ed45f0fbbb6e2$export$45d219bdcd8ac53c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $6e5ed45f0fbbb6e2$export$766bf7dcfb630b6c {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: $6e5ed45f0fbbb6e2$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $6e5ed45f0fbbb6e2$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $6e5ed45f0fbbb6e2$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $6e5ed45f0fbbb6e2$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$6e5ed45f0fbbb6e2$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$6e5ed45f0fbbb6e2$export$674f8f4247a5112e(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
}
function $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $6e5ed45f0fbbb6e2$export$674f8f4247a5112e(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function $6e5ed45f0fbbb6e2$export$d76842aa27385215(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($6e5ed45f0fbbb6e2$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $6e5ed45f0fbbb6e2$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $6e5ed45f0fbbb6e2$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $6e5ed45f0fbbb6e2$export$b0165a7e514844(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $6e5ed45f0fbbb6e2$export$b2bcef12bcefba04 {
    constructor(el, selector){
        this.emitter = new $6e5ed45f0fbbb6e2$export$d66501df72047452();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $6e5ed45f0fbbb6e2$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $6e5ed45f0fbbb6e2$var$DRAG_META_REFINERS = {
    startTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    duration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $6e5ed45f0fbbb6e2$export$60bb826a6acf3081(raw) {
    let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, $6e5ed45f0fbbb6e2$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $6e5ed45f0fbbb6e2$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'long'
    }); // "Saturday"
}
const $6e5ed45f0fbbb6e2$var$CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function $6e5ed45f0fbbb6e2$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class $6e5ed45f0fbbb6e2$export$ebc5e65867841cbe extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
        let classNames = [
            $6e5ed45f0fbbb6e2$var$CLASS_NAME
        ].concat($6e5ed45f0fbbb6e2$export$1a8f5705751d8277(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $6e5ed45f0fbbb6e2$export$a17c37559e1db147(this.context, date) : {};
        let publicDate = dateEnv.toDate(date);
        // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
        // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
        if (dateEnv.namedTimeZoneImpl) publicDate = $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: publicDate,
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan,
                'data-date': !dayMeta.isDisabled ? $6e5ed45f0fbbb6e2$export$56350196709588fc(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ]
            })));
    }
}
const $6e5ed45f0fbbb6e2$var$WEEKDAY_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    weekday: 'long'
});
class $6e5ed45f0fbbb6e2$export$1ddf2d01943a3512 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $6e5ed45f0fbbb6e2$var$CLASS_NAME,
                ...$6e5ed45f0fbbb6e2$export$1a8f5705751d8277(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ],
                elAttrs: {
                    'aria-label': dateEnv.format(date, $6e5ed45f0fbbb6e2$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $6e5ed45f0fbbb6e2$export$27d1aff6bea49709 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$createDayHeaderFormatter);
    }
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$2e2af4578d910ddf, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                role: "row"
            }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$ebc5e65867841cbe, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$1ddf2d01943a3512, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function $6e5ed45f0fbbb6e2$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $6e5ed45f0fbbb6e2$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
class $6e5ed45f0fbbb6e2$export$ebb8f7cd71856fb9 {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($6e5ed45f0fbbb6e2$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class $6e5ed45f0fbbb6e2$export$1314441b8d04e1d5 {
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class $6e5ed45f0fbbb6e2$export$e0c3a065614c6254 {
    constructor(){
        this.sliceBusinessHours = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($6e5ed45f0fbbb6e2$var$expandRecurring(businessHours, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(eventStore, eventUiBases, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $6e5ed45f0fbbb6e2$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
            start: dateRange.start,
            end: $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$6d1e945284085e64(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$6e5ed45f0fbbb6e2$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $6e5ed45f0fbbb6e2$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $6e5ed45f0fbbb6e2$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$6e5ed45f0fbbb6e2$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $6e5ed45f0fbbb6e2$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $6e5ed45f0fbbb6e2$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $6e5ed45f0fbbb6e2$export$6b179bb11f7fd3a0)(props, context);
}
function $6e5ed45f0fbbb6e2$export$6b179bb11f7fd3a0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$6e5ed45f0fbbb6e2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$6e5ed45f0fbbb6e2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $6e5ed45f0fbbb6e2$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$6e5ed45f0fbbb6e2$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($6e5ed45f0fbbb6e2$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, origDef, origInstance);
            else eventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$6e5ed45f0fbbb6e2$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($6e5ed45f0fbbb6e2$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$6e5ed45f0fbbb6e2$var$anyRangesContainRange($6e5ed45f0fbbb6e2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === 'object' && constraint) return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $6e5ed45f0fbbb6e2$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $6e5ed45f0fbbb6e2$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($6e5ed45f0fbbb6e2$export$f074adc9fbd50943(outerRange, innerRange)) return true;
    }
    return false;
}
const $6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $6e5ed45f0fbbb6e2$export$54c4fabc2291e9c0 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            'fc-scroller'
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
            else className.push('fc-scroller-liquid');
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.handleEl,
            className: className.join(' '),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || '',
                right: isAbsolute && -(props.overcomeRight || 0) || '',
                bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                maxHeight: props.maxHeight || ''
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $6e5ed45f0fbbb6e2$export$807f1ba34db587c7 {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $6e5ed45f0fbbb6e2$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(this.currentMap);
    }
}
function $6e5ed45f0fbbb6e2$export$7fe88b5920ffddd2(chunkEls) {
    let shrinkCells = $6e5ed45f0fbbb6e2$export$23ebac1979863676(chunkEls, '.fc-scrollgrid-shrink');
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $6e5ed45f0fbbb6e2$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $6e5ed45f0fbbb6e2$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $6e5ed45f0fbbb6e2$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $6e5ed45f0fbbb6e2$export$f5339a28e56d1baf(cols0, cols1) {
    return $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(cols0, cols1, $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca);
}
function $6e5ed45f0fbbb6e2$export$add49c223b9ce4ea(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("col", {
            style: {
                width: colProps.width === 'shrink' ? $6e5ed45f0fbbb6e2$export$df7c425476ed4f2(shrinkWidth) : colProps.width || '',
                minWidth: colProps.minWidth || ''
            }
        }));
    }
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('colgroup', {}, ...colNodes);
}
function $6e5ed45f0fbbb6e2$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $6e5ed45f0fbbb6e2$export$c69d65aa55814164(cols) {
    for (let col of cols){
        if (col.width === 'shrink') return true;
    }
    return false;
}
function $6e5ed45f0fbbb6e2$export$65ab0ebced932b79(liquid, context) {
    let classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    let classNames = [
        'fc-scrollgrid-section',
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290(arg) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $6e5ed45f0fbbb6e2$export$89e9012e902952b6(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function $6e5ed45f0fbbb6e2$export$4ad369a19af21c23(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
class $6e5ed45f0fbbb6e2$export$c667925124dac624 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.processCols = $6e5ed45f0fbbb6e2$export$df995fae86a55f06((a)=>a, $6e5ed45f0fbbb6e2$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$export$add49c223b9ce4ea);
        this.scrollerRefs = new $6e5ed45f0fbbb6e2$export$807f1ba34db587c7();
        this.scrollerElRefs = new $6e5ed45f0fbbb6e2$export$807f1ba34db587c7(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $6e5ed45f0fbbb6e2$export$65ab0ebced932b79(props.liquid, context);
        if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9();
        const roleAttrs = {
            role: 'rowgroup'
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $6e5ed45f0fbbb6e2$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(' ')
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $6e5ed45f0fbbb6e2$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
        let sectionKey = sectionConfig.key;
        let content = $6e5ed45f0fbbb6e2$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation'
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$54c4fabc2291e9c0, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $6e5ed45f0fbbb6e2$var$getSectionByKey(this.props.sections, key);
        if (section) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $6e5ed45f0fbbb6e2$export$c69d65aa55814164(this.props.cols) ? $6e5ed45f0fbbb6e2$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $6e5ed45f0fbbb6e2$export$a1edd97dd51cd48d();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
}
$6e5ed45f0fbbb6e2$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
function $6e5ed45f0fbbb6e2$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $6e5ed45f0fbbb6e2$export$c1df809846363ebe extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        // memo
        this.buildPublicEvent = $6e5ed45f0fbbb6e2$export$df995fae86a55f06((context, eventDef, eventInstance)=>new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, eventDef, eventInstance));
        this.handleEl = (el)=>{
            this.el = el;
            $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
            if (el) $6e5ed45f0fbbb6e2$var$setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $6e5ed45f0fbbb6e2$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $6e5ed45f0fbbb6e2$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $6e5ed45f0fbbb6e2$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: this.handleEl,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6e5ed45f0fbbb6e2$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }, props.children);
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $6e5ed45f0fbbb6e2$var$setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class $6e5ed45f0fbbb6e2$export$6735ce526161c7bd extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $6e5ed45f0fbbb6e2$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $6e5ed45f0fbbb6e2$export$6dabbe08653f866f(seg, context),
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-event-main'
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
$6e5ed45f0fbbb6e2$export$6735ce526161c7bd.addPropsEquality({
    seg: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
function $6e5ed45f0fbbb6e2$var$renderInnerContent$1(innerProps) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title-container"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "\u00A0"))));
}
const $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012 = (props)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
const $6e5ed45f0fbbb6e2$var$DAY_NUM_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    day: 'numeric'
});
class $6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.refineRenderProps = $6e5ed45f0fbbb6e2$export$ebd11618f299a286($6e5ed45f0fbbb6e2$var$refineRenderProps);
    }
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                'data-date': $6e5ed45f0fbbb6e2$export$56350196709588fc(props.date)
            }),
            elClasses: [
                ...$6e5ed45f0fbbb6e2$export$1a8f5705751d8277(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }, props.children);
    }
}
function $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler('dayCellContent', options));
}
function $6e5ed45f0fbbb6e2$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $6e5ed45f0fbbb6e2$var$DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $6e5ed45f0fbbb6e2$export$b02498c06ddfef28 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$c1df809846363ebe, {
            elTag: "div",
            elClasses: [
                'fc-bg-event'
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $6e5ed45f0fbbb6e2$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $6e5ed45f0fbbb6e2$export$b975d55abac2bbe3(fillType) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: `fc-${fillType}`
    });
}
const $6e5ed45f0fbbb6e2$export$1343a74baacb0543 = (props)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
function $6e5ed45f0fbbb6e2$var$renderInner(innerProps) {
    return innerProps.text;
}
const $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT = 10;
class $6e5ed45f0fbbb6e2$var$Popover extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $6e5ed45f0fbbb6e2$export$2ed0fc6709e59212(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === 'Escape') this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            'fc-popover',
            theme.getClass('popover')
        ].concat(props.extraClassNames || []);
        return (0, $e21355414fd2bd2a$export$d39a5bbd09211389)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(' '),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: 'fc-popover-header ' + theme.getClass('popoverHeader')
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: 'fc-popover-close ' + theme.getIconClass('close'),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: 'fc-popover-body ' + theme.getClass('popoverContent')
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $6e5ed45f0fbbb6e2$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $6e5ed45f0fbbb6e2$export$faec65b429be379(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class $6e5ed45f0fbbb6e2$var$MorePopover extends $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    'fc-more-popover'
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0(options) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-more-popover-misc'
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class $6e5ed45f0fbbb6e2$export$87b6ab1c2cb8b955 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $6e5ed45f0fbbb6e2$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $6e5ed45f0fbbb6e2$var$computeRange(props);
            let text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, Boolean(props.moreCnt) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
                elTag: props.elTag || 'a',
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    'fc-more-link'
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    'aria-expanded': state.isPopoverOpen,
                    'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $6e5ed45f0fbbb6e2$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($6e5ed45f0fbbb6e2$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(this.linkEl, '.fc-view-harness');
    }
}
function $6e5ed45f0fbbb6e2$var$renderMoreLinkInner(props) {
    return props.text;
}
function $6e5ed45f0fbbb6e2$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73(hiddenSegs),
        end: $6e5ed45f0fbbb6e2$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73(segs) {
    return segs.reduce($6e5ed45f0fbbb6e2$var$pickEarliestStart).eventRange.range.start;
}
function $6e5ed45f0fbbb6e2$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $6e5ed45f0fbbb6e2$var$computeLatestSegEnd(segs) {
    return segs.reduce($6e5ed45f0fbbb6e2$var$pickLatestEnd).eventRange.range.end;
}
function $6e5ed45f0fbbb6e2$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $6e5ed45f0fbbb6e2$var$Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $6e5ed45f0fbbb6e2$export$1776704b6532a19a extends $6e5ed45f0fbbb6e2$var$Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}




const $e05f80c7548aefed$export$794e7bef9c0b12d9 = [];
const $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
const $e05f80c7548aefed$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today (buttonText, unit) {
            return unit === 'day' ? 'Today' : `This ${buttonText}`;
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
    }
});
function $e05f80c7548aefed$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    let allRawLocales = $e05f80c7548aefed$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $e05f80c7548aefed$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $e05f80c7548aefed$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return $e05f80c7548aefed$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $e05f80c7548aefed$var$queryLocale(inputSingular, available);
}
function $e05f80c7548aefed$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $e05f80c7548aefed$var$queryRawLocale(codes, available) || $e05f80c7548aefed$var$RAW_EN_LOCALE;
    return $e05f80c7548aefed$var$parseLocale(codeArg, codes, raw);
}
function $e05f80c7548aefed$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split('-');
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $e05f80c7548aefed$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $6e5ed45f0fbbb6e2$export$953cecd6e717a553)([
        $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $e05f80c7548aefed$export$ae829ec7b2625219(input) {
    return {
        id: (0, $6e5ed45f0fbbb6e2$export$39b482c5e57630a8)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $e05f80c7548aefed$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $e05f80c7548aefed$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $e05f80c7548aefed$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef)(overrideDefs, currentOverrideDefs) || !(0, $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef)(globalDefs, currentGlobalDefs)) currentHooks = $e05f80c7548aefed$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $e05f80c7548aefed$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $e05f80c7548aefed$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $e05f80c7548aefed$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $e05f80c7548aefed$var$StandardTheme extends (0, $6e5ed45f0fbbb6e2$export$971d5caa766a69d7) {
}
$e05f80c7548aefed$var$StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
$e05f80c7548aefed$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
$e05f80c7548aefed$var$StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
$e05f80c7548aefed$var$StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function $e05f80c7548aefed$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $e05f80c7548aefed$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $e05f80c7548aefed$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp('component');
    let superType = queryProp('superType');
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = $e05f80c7548aefed$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $e05f80c7548aefed$var$parseViewConfigs(inputs) {
    return (0, $6e5ed45f0fbbb6e2$export$407448d2b89b1813)(inputs, $e05f80c7548aefed$var$parseViewConfig);
}
function $e05f80c7548aefed$var$parseViewConfig(input) {
    let rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $e05f80c7548aefed$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $e05f80c7548aefed$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $e05f80c7548aefed$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7c866399fa523f5).Consumer, null, (context)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
                elTag: "div",
                elClasses: (0, $6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $e05f80c7548aefed$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $e05f80c7548aefed$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $e05f80c7548aefed$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $e05f80c7548aefed$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $6e5ed45f0fbbb6e2$export$407448d2b89b1813)(viewDefs, (viewDef)=>$e05f80c7548aefed$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $e05f80c7548aefed$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = '';
    let singleUnit = '';
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $e05f80c7548aefed$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $6e5ed45f0fbbb6e2$export$db3b6bfb95261072)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $6e5ed45f0fbbb6e2$export$f1e1789686576879)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $6e5ed45f0fbbb6e2$export$f1e1789686576879))
    };
}
// hack to get memoization working
let $e05f80c7548aefed$var$durationInputMap = {};
function $e05f80c7548aefed$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $e05f80c7548aefed$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0)(durationInput);
        $e05f80c7548aefed$var$durationInputMap[json] = res;
    }
    return res;
}
function $e05f80c7548aefed$var$reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function $e05f80c7548aefed$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $e05f80c7548aefed$var$getInitialDate(options, dateEnv, nowManager) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $e05f80c7548aefed$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $e05f80c7548aefed$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $e05f80c7548aefed$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $e05f80c7548aefed$var$addSources({}, $e05f80c7548aefed$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $e05f80c7548aefed$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return $e05f80c7548aefed$var$addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return $e05f80c7548aefed$var$removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $e05f80c7548aefed$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return $e05f80c7548aefed$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $6e5ed45f0fbbb6e2$export$2d1720544b23b823)(action.sourceIds) : $e05f80c7548aefed$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return $e05f80c7548aefed$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function $e05f80c7548aefed$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $e05f80c7548aefed$var$fetchSourcesByIds(eventSources, $e05f80c7548aefed$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $e05f80c7548aefed$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $e05f80c7548aefed$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $e05f80c7548aefed$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $e05f80c7548aefed$var$removeSource(eventSourceHash, sourceId) {
    return (0, $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $e05f80c7548aefed$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $e05f80c7548aefed$var$fetchSourcesByIds(sourceHash, (0, $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9)(sourceHash, (eventSource)=>$e05f80c7548aefed$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $e05f80c7548aefed$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $e05f80c7548aefed$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $e05f80c7548aefed$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $e05f80c7548aefed$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $6e5ed45f0fbbb6e2$export$39b482c5e57630a8)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $e05f80c7548aefed$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $e05f80c7548aefed$var$excludeStaticSources(eventSources, context) {
    return (0, $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9)(eventSources, (eventSource)=>$e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context));
}
function $e05f80c7548aefed$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $6e5ed45f0fbbb6e2$export$35e795649ee09318)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $6e5ed45f0fbbb6e2$export$ffb5f4729a158638)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $e05f80c7548aefed$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function $e05f80c7548aefed$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $e05f80c7548aefed$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $e05f80c7548aefed$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $e05f80c7548aefed$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $e05f80c7548aefed$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $e05f80c7548aefed$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $e05f80c7548aefed$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $e05f80c7548aefed$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $e05f80c7548aefed$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === 'rtl';
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $6e5ed45f0fbbb6e2$export$342063e11d6c3cad)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, $6e5ed45f0fbbb6e2$export$342063e11d6c3cad)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $6e5ed45f0fbbb6e2$export$342063e11d6c3cad)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $e05f80c7548aefed$var$ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let $e05f80c7548aefed$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $e05f80c7548aefed$var$arrayEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'array-event-source',
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef$2
    ]
});
let $e05f80c7548aefed$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $6e5ed45f0fbbb6e2$export$3b14a55fb2447963)(func.bind(null, (0, $6e5ed45f0fbbb6e2$export$882b5998b3b9117c)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $e05f80c7548aefed$var$funcEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'func-event-source',
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef$1
    ]
});
const $e05f80c7548aefed$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $e05f80c7548aefed$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $e05f80c7548aefed$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $6e5ed45f0fbbb6e2$export$43caf9889c228507)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $e05f80c7548aefed$var$jsonFeedEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'json-event-source',
    eventSourceRefiners: $e05f80c7548aefed$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef
    ]
});
function $e05f80c7548aefed$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $e05f80c7548aefed$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    startTime: (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0),
    endTime: (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0),
    duration: (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0),
    startRecur: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    endRecur: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5)
};
let $e05f80c7548aefed$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $6e5ed45f0fbbb6e2$export$2408f22a0fab9ae5)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $6e5ed45f0fbbb6e2$export$ae1af26003f05816)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $e05f80c7548aefed$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
const $e05f80c7548aefed$var$simpleRecurringEventsPlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'simple-recurring-event',
    recurringTypes: [
        $e05f80c7548aefed$var$recurring
    ],
    eventRefiners: $e05f80c7548aefed$var$SIMPLE_RECURRING_REFINERS
});
function $e05f80c7548aefed$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    let dowHash = daysOfWeek ? (0, $6e5ed45f0fbbb6e2$export$2d1720544b23b823)(daysOfWeek) : null;
    let dayMarker = (0, $6e5ed45f0fbbb6e2$export$9e5f44173e64f162)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(dayMarker, 1);
    }
    return instanceStarts;
}
const $e05f80c7548aefed$var$changeHandlerPlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'change-handler',
    optionChangeHandlers: {
        events (events, context) {
            $e05f80c7548aefed$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $e05f80c7548aefed$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $e05f80c7548aefed$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $6e5ed45f0fbbb6e2$export$90a7f3efeed30595)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $e05f80c7548aefed$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, $6e5ed45f0fbbb6e2$export$882b5998b3b9117c)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $e05f80c7548aefed$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $e05f80c7548aefed$export$905153d94e0757fa = [
    $e05f80c7548aefed$var$arrayEventSourcePlugin,
    $e05f80c7548aefed$var$funcEventSourcePlugin,
    $e05f80c7548aefed$var$jsonFeedEventSourcePlugin,
    $e05f80c7548aefed$var$simpleRecurringEventsPlugin,
    $e05f80c7548aefed$var$changeHandlerPlugin,
    $e05f80c7548aefed$export$ae829ec7b2625219({
        name: 'misc',
        isLoadingFuncs: [
            (state)=>$e05f80c7548aefed$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $e05f80c7548aefed$var$handleDateProfile,
            eventStore: $e05f80c7548aefed$var$handleEventStore
        }
    })
];
class $e05f80c7548aefed$var$TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $6e5ed45f0fbbb6e2$export$96f57966bedc81b4)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $e05f80c7548aefed$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(viewOptions.titleFormat || $e05f80c7548aefed$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $e05f80c7548aefed$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    let days = (0, $6e5ed45f0fbbb6e2$export$4a5767248b18ef41)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ class $e05f80c7548aefed$var$CalendarNowManager {
    constructor(){
        this.resetListeners = new Set();
    }
    handleInput(dateEnv, nowInput) {
        const oldDateEnv = this.dateEnv;
        if (dateEnv !== oldDateEnv) {
            if (typeof nowInput === 'function') this.nowFn = nowInput;
            else if (!oldDateEnv) {
                this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                this.nowAnchorQueried = Date.now();
            }
            this.dateEnv = dateEnv;
            // not first time? fire reset handlers
            if (oldDateEnv) for (const resetListener of this.resetListeners.values())resetListener();
        }
    }
    getDateMarker() {
        return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
    }
    addResetListener(handler) {
        this.resetListeners.add(handler);
    }
    removeResetListener(handler) {
        this.resetListeners.delete(handler);
    }
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $e05f80c7548aefed$var$CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$organizeRawLocales);
        this.buildLocale = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildLocale);
        this.buildPluginHooks = $e05f80c7548aefed$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildDateEnv$1);
        this.buildTheme = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildTheme);
        this.parseToolbars = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$parseToolbars);
        this.buildViewSpecs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $6e5ed45f0fbbb6e2$export$ebd11618f299a286)($e05f80c7548aefed$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildViewApi);
        this.buildViewUiProps = (0, $6e5ed45f0fbbb6e2$export$ebd11618f299a286)($e05f80c7548aefed$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildEventUiBySource, (0, $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca));
        this.buildEventUiBases = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $6e5ed45f0fbbb6e2$export$ebd11618f299a286)($e05f80c7548aefed$var$parseContextBusinessHours);
        this.buildTitle = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildTitle);
        this.nowManager = new $e05f80c7548aefed$var$CalendarNowManager();
        this.emitter = new (0, $6e5ed45f0fbbb6e2$export$d66501df72047452)();
        this.actionRunner = new $e05f80c7548aefed$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $e05f80c7548aefed$var$CalendarNowManager();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        let currentDate = $e05f80c7548aefed$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $e05f80c7548aefed$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd)(),
            renderableEventStore: (0, $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($e05f80c7548aefed$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: 'NOTHING'
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $e05f80c7548aefed$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $e05f80c7548aefed$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = $e05f80c7548aefed$var$reduceCurrentDate(currentDate, action);
        dateProfile = $e05f80c7548aefed$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
        action.type === 'NEXT' || // "
        !(0, $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $e05f80c7548aefed$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $6e5ed45f0fbbb6e2$export$9bb611d729802a56)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $e05f80c7548aefed$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $e05f80c7548aefed$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $e05f80c7548aefed$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $e05f80c7548aefed$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $e05f80c7548aefed$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $e05f80c7548aefed$var$computeIsLoading(state, calendarContext);
        let isLoading = $e05f80c7548aefed$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger('loading', true);
        else if (wasLoading && !isLoading) emitter.trigger('loading', false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            nowManager: this.nowManager,
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $e05f80c7548aefed$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $6e5ed45f0fbbb6e2$export$b4171a6734a65d42)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $6e5ed45f0fbbb6e2$export$b4171a6734a65d42)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $e05f80c7548aefed$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $6e5ed45f0fbbb6e2$export$3466f893ebf79586)([
            (0, $6e5ed45f0fbbb6e2$export$f1e1789686576879),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $e05f80c7548aefed$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $6e5ed45f0fbbb6e2$export$61196ced6d74a310)), (0, $6e5ed45f0fbbb6e2$export$3a1a48c8f6ef640e)), (0, $6e5ed45f0fbbb6e2$export$a07804094c3ecf2d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $6e5ed45f0fbbb6e2$export$3466f893ebf79586)([
            (0, $6e5ed45f0fbbb6e2$export$f1e1789686576879),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName] && optionName in currentRaw && (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $e05f80c7548aefed$var$warnUnknownOptions(extra);
        this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            nowManager: this.nowManager,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $6e5ed45f0fbbb6e2$export$3466f893ebf79586)([
            (0, $6e5ed45f0fbbb6e2$export$f1e1789686576879),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $6e5ed45f0fbbb6e2$export$61196ced6d74a310)), (0, $6e5ed45f0fbbb6e2$export$3a1a48c8f6ef640e)), (0, $6e5ed45f0fbbb6e2$export$a07804094c3ecf2d)), (0, $6e5ed45f0fbbb6e2$export$56c0d5a1e737357d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName] && (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName] && (0, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
}
function $e05f80c7548aefed$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $e05f80c7548aefed$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $6e5ed45f0fbbb6e2$export$3722cfe417b6ed86)({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $e05f80c7548aefed$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $e05f80c7548aefed$var$StandardTheme;
    return new ThemeClass(options);
}
function $e05f80c7548aefed$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $6e5ed45f0fbbb6e2$export$db202ddc8be9136);
    return new DateProfileGeneratorClass(props);
}
function $e05f80c7548aefed$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $e05f80c7548aefed$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $e05f80c7548aefed$var$buildEventUiBySource(eventSources) {
    return (0, $6e5ed45f0fbbb6e2$export$407448d2b89b1813)(eventSources, (eventSource)=>eventSource.ui);
}
function $e05f80c7548aefed$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        '': eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $e05f80c7548aefed$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $6e5ed45f0fbbb6e2$export$25ce5a424b770e84)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $6e5ed45f0fbbb6e2$export$25ce5a424b770e84)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $e05f80c7548aefed$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $e05f80c7548aefed$var$parseContextBusinessHours(calendarContext) {
    return (0, $6e5ed45f0fbbb6e2$export$3a6d5c9ae78a2c08)(calendarContext.options.businessHours, calendarContext);
}
function $e05f80c7548aefed$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
}
class $e05f80c7548aefed$var$ToolbarSection extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('div', {
            className: 'fc-toolbar-chunk'
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass('button')
                ];
                if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                children.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("button", {
                    type: "button",
                    title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(' '),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : '')));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)('div', {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $e05f80c7548aefed$var$Toolbar extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : ''
        ];
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: classNames.join(' ')
        }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e05f80c7548aefed$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $e05f80c7548aefed$var$ViewHarness extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $6e5ed45f0fbbb6e2$export$71cec2538cb2c617)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            'fc-view-harness',
            aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
             : 'fc-view-harness-passive'
        ];
        let height = '';
        let paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || '';
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(' '),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $e05f80c7548aefed$var$EventClicking extends (0, $6e5ed45f0fbbb6e2$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $6e5ed45f0fbbb6e2$export$8743009a87fcb00f)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758)(ev.target, '.fc-event-forced-url');
                let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, $6e5ed45f0fbbb6e2$export$71511d61b312f219)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9)(settings.el, 'click', '.fc-event', this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $e05f80c7548aefed$var$EventHovering extends (0, $6e5ed45f0fbbb6e2$export$78acf4525d8a74c4) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $6e5ed45f0fbbb6e2$export$8743009a87fcb00f)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $6e5ed45f0fbbb6e2$export$34aec0b863436764)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $6e5ed45f0fbbb6e2$export$8743009a87fcb00f)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $6e5ed45f0fbbb6e2$export$71511d61b312f219)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class $e05f80c7548aefed$var$CalendarContent extends (0, $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)((0, $6e5ed45f0fbbb6e2$export$ce26c07117d59d6a));
        this.buildViewPropTransformers = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($e05f80c7548aefed$var$buildToolbarProps);
        this.headerRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.footerRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $6e5ed45f0fbbb6e2$export$efca4cbe5dd06740)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $e05f80c7548aefed$var$EventClicking,
                $e05f80c7548aefed$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $6e5ed45f0fbbb6e2$export$a8550f7dbe79f93a)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $6e5ed45f0fbbb6e2$export$a8550f7dbe79f93a)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $6e5ed45f0fbbb6e2$export$96f57966bedc81b4)(()=>{
            this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger('windowResize', {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let viewVGrow = false;
        let viewHeight = '';
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = '';
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7c866399fa523f5).Provider, {
            value: viewContext
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf), {
            unit: "day"
        }, (nowDate)=>{
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, toolbarConfig.header && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e05f80c7548aefed$var$Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e05f80c7548aefed$var$ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e05f80c7548aefed$var$Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener('resize', this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger('_unmount');
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(ViewComponent, Object.assign({}, viewProps));
    }
}
function $e05f80c7548aefed$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $e05f80c7548aefed$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $e05f80c7548aefed$export$e1aef45b828286de extends (0, $6e5ed45f0fbbb6e2$export$a93c5207d687da10) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $6e5ed45f0fbbb6e2$export$c3950d9923825c02)(()=>{
                    (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a9c996f45e5784d0), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de).Provider, {
                            value: this.customContentRenderId
                        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e05f80c7548aefed$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, this.el);
                this.setClassNames([]);
                this.setHeight('');
            }
        };
        (0, $6e5ed45f0fbbb6e2$export$555508cbc6add439)(el);
        this.el = el;
        this.renderRunner = new (0, $6e5ed45f0fbbb6e2$export$96f57966bedc81b4)(this.handleRenderRequest);
        new $e05f80c7548aefed$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $6e5ed45f0fbbb6e2$export$c3950d9923825c02)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    }
    pauseRendering() {
        this.renderRunner.pause('pauseRendering');
    }
    resumeRendering() {
        this.renderRunner.resume('pauseRendering', true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $6e5ed45f0fbbb6e2$export$2219238a014317b0)(this.el, 'height', height);
    }
}
function $e05f80c7548aefed$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $e05f80c7548aefed$var$buildDateEnv(options);
    let formatter = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $e05f80c7548aefed$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $e05f80c7548aefed$var$buildDateEnv(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    let formatter = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $6e5ed45f0fbbb6e2$export$f1e1789686576879).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $e05f80c7548aefed$var$buildDateEnv(settings) {
    let locale = $e05f80c7548aefed$var$buildLocale(settings.locale || 'en', $e05f80c7548aefed$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $6e5ed45f0fbbb6e2$export$3722cfe417b6ed86)(Object.assign(Object.assign({
        timeZone: (0, $6e5ed45f0fbbb6e2$export$f1e1789686576879).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $e05f80c7548aefed$export$3b384895d0cca0f2(props, allDay) {
    return (0, $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $e05f80c7548aefed$export$83d89fbfd8236492 = '6.1.19';





/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $000f37fb542d3ff1$export$b3c27e869d856b7 extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $6e5ed45f0fbbb6e2$export$89e9012e902952b6)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c667925124dac624), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $6e5ed45f0fbbb6e2$export$89e9012e902952b6)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $6e5ed45f0fbbb6e2$export$4ad369a19af21c23)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: 'main',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [
                {
                    key: 'main',
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: 'footer',
            key: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'main',
                    content: (0, $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290)
                }
            ]
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function $000f37fb542d3ff1$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $000f37fb542d3ff1$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $000f37fb542d3ff1$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function $000f37fb542d3ff1$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $000f37fb542d3ff1$var$TableBlockEvent extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$6735ce526161c7bd), Object.assign({}, props, {
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-block-event',
                'fc-h-event'
            ],
            defaultTimeFormat: $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $000f37fb542d3ff1$var$TableListItemEvent extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $6e5ed45f0fbbb6e2$export$2538633961795d6b)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c1df809846363ebe), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-dot-event'
            ],
            elAttrs: (0, $6e5ed45f0fbbb6e2$export$6dabbe08653f866f)(props.seg, context),
            defaultGenerator: $000f37fb542d3ff1$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $000f37fb542d3ff1$var$renderInnerContent(renderProps) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "\u00A0")));
}
class $000f37fb542d3ff1$var$TableCellMoreLink extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$compileSegs);
    }
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$87b6ab1c2cb8b955), {
            elClasses: [
                'fc-daygrid-more-link'
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                        }
                    }, $000f37fb542d3ff1$var$hasListItemDisplay(seg) ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, props.todayRange))) : (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function $000f37fb542d3ff1$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $000f37fb542d3ff1$var$DEFAULT_WEEK_NUM_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    week: 'narrow'
});
class $000f37fb542d3ff1$var$TableCell extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.state = {
            dayNumberId: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)()
        };
        this.handleRootEl = (el)=>{
            (0, $6e5ed45f0fbbb6e2$export$71cec2538cb2c617)(this.rootElRef, el);
            (0, $6e5ed45f0fbbb6e2$export$71cec2538cb2c617)(this.props.elRef, el);
        };
    }
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $000f37fb542d3ff1$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                'fc-daygrid-day',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                'aria-labelledby': state.dayNumberId
            } : {}), {
                role: 'gridcell'
            }),
            defaultGenerator: $000f37fb542d3ff1$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$1343a74baacb0543), {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-week-number'
                ],
                elAttrs: (0, $6e5ed45f0fbbb6e2$export$a17c37559e1db147)(context, date, 'week'),
                date: date,
                defaultFormat: $000f37fb542d3ff1$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0)(options) || props.forceDayTop) ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-day-number',
                    isMonthStart && 'fc-daygrid-month-start'
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $6e5ed45f0fbbb6e2$export$a17c37559e1db147)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: 'hidden'
                }
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
                className: "fc-daygrid-day-number"
            }, "\u00A0")) : undefined, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function $000f37fb542d3ff1$var$renderTopInner(props) {
    return props.dayNumberText || (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "\u00A0");
}
function $000f37fb542d3ff1$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $000f37fb542d3ff1$var$generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function $000f37fb542d3ff1$var$generateSegUid(seg) {
    return $000f37fb542d3ff1$var$generateSegKey(seg) + ':' + seg.lastCol;
}
function $000f37fb542d3ff1$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new $000f37fb542d3ff1$var$DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = $000f37fb542d3ff1$var$generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $000f37fb542d3ff1$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $000f37fb542d3ff1$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $000f37fb542d3ff1$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $000f37fb542d3ff1$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $000f37fb542d3ff1$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $000f37fb542d3ff1$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $000f37fb542d3ff1$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $000f37fb542d3ff1$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $6e5ed45f0fbbb6e2$export$ae1af26003f05816)(origRange, {
        start: cells[spanStart].date,
        end: (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $000f37fb542d3ff1$var$DayGridSegHierarchy extends (0, $6e5ed45f0fbbb6e2$export$766bf7dcfb630b6c) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $6e5ed45f0fbbb6e2$export$674f8f4247a5112e)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $6e5ed45f0fbbb6e2$export$674f8f4247a5112e)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $6e5ed45f0fbbb6e2$export$b0165a7e514844)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, $6e5ed45f0fbbb6e2$export$674f8f4247a5112e)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class $000f37fb542d3ff1$var$TableRow extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)(); // the <td>
        this.frameElRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $000f37fb542d3ff1$var$computeFgSegPlacement((0, $6e5ed45f0fbbb6e2$export$a91cd623adc48128)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $000f37fb542d3ff1$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, normalFgNodes), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, mirrorFgNodes)),
                bgContent: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = '';
            let right = '';
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                key: $000f37fb542d3ff1$var$generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef($000f37fb542d3ff1$var$generateSegUid(seg)),
                style: {
                    visibility: isVisible ? '' : 'hidden',
                    marginTop: isAbsolute ? '' : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : '',
                    left: left,
                    right: right
                }
            }, $000f37fb542d3ff1$var$hasListItemDisplay(seg) ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange))) : (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                key: (0, $6e5ed45f0fbbb6e2$export$4d522598b426bb73)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === 'bg-event' ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$b02498c06ddfef28), Object.assign({
                seg: seg
            }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange))) : (0, $6e5ed45f0fbbb6e2$export$b975d55abac2bbe3)(fillType)));
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
$000f37fb542d3ff1$var$TableRow.addStateEquality({
    segHeights: (0, $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca)
});
function $000f37fb542d3ff1$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $000f37fb542d3ff1$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $000f37fb542d3ff1$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $000f37fb542d3ff1$export$d955b1c53830e05a extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitAllDaySegsByRow);
        this.splitFgEventSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitEventDrag = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitInteractionByRow);
        this.splitEventResize = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$var$splitInteractionByRow);
        this.rowRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)();
    }
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, props.cells.map((cells, row)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row],
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(start, 1);
        return {
            start: start,
            end: end
        };
    }
}
function $000f37fb542d3ff1$var$splitAllDaySegsByRow(segs, rowCnt) {
    return $000f37fb542d3ff1$var$splitSegsByRow(segs.filter($000f37fb542d3ff1$var$isSegAllDay), rowCnt);
}
function $000f37fb542d3ff1$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $000f37fb542d3ff1$export$54ec01a60f47d33d extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.needsScrollReset = false;
    }
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural'
        ];
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.elRef,
            className: classNames.join(' '),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ''
            }
        }, props.colGroupNode, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $000f37fb542d3ff1$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest('.fc-daygrid-body');
                const scrollEl = originEl.closest('.fc-scroller');
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function $000f37fb542d3ff1$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $6e5ed45f0fbbb6e2$export$5dbe06c6d8c68cfb)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $6e5ed45f0fbbb6e2$export$56350196709588fc)(dateProfile.currentDate)}"]`);
    return el;
}
class $000f37fb542d3ff1$export$eb38be9553e58392 extends (0, $6e5ed45f0fbbb6e2$export$e0c3a065614c6254) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class $000f37fb542d3ff1$export$cd402b7558adf371 extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.slicer = new $000f37fb542d3ff1$export$eb38be9553e58392();
        this.tableRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class $000f37fb542d3ff1$export$39eed66de95896e5 extends $000f37fb542d3ff1$export$b3c27e869d856b7 {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($000f37fb542d3ff1$export$61e79f95d746b006);
        this.headerRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.tableRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$27d1aff6bea49709), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($000f37fb542d3ff1$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function $000f37fb542d3ff1$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $6e5ed45f0fbbb6e2$export$ebb8f7cd71856fb9)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $6e5ed45f0fbbb6e2$export$1314441b8d04e1d5)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class $000f37fb542d3ff1$export$9fcce6e2d16ec31d extends (0, $6e5ed45f0fbbb6e2$export$db202ddc8be9136) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $000f37fb542d3ff1$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $000f37fb542d3ff1$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $6e5ed45f0fbbb6e2$export$151db275011178c4)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $6e5ed45f0fbbb6e2$export$136fd86de524d3c2)(lastMonthRenderStart, end));
        end = (0, $6e5ed45f0fbbb6e2$export$151db275011178c4)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var $000f37fb542d3ff1$var$css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75)($000f37fb542d3ff1$var$css_248z);




var $ff6c31a575eac43e$export$2e2bcd8739ae039 = (0, $e05f80c7548aefed$export$ae829ec7b2625219)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, $000f37fb542d3ff1$export$39eed66de95896e5),
            dateProfileGeneratorClass: (0, $000f37fb542d3ff1$export$9fcce6e2d16ec31d)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});






class $0b388de944c7beb8$var$AllDaySplitter extends (0, $6e5ed45f0fbbb6e2$export$9d0e2d13d04f7070) {
    getKeyInfo() {
        return {
            allDay: {},
            timed: {}
        };
    }
    getKeysForDateSpan(dateSpan) {
        if (dateSpan.allDay) return [
            'allDay'
        ];
        return [
            'timed'
        ];
    }
    getKeysForEventDef(eventDef) {
        if (!eventDef.allDay) return [
            'timed'
        ];
        if ((0, $6e5ed45f0fbbb6e2$export$45aabb5431c2d04f)(eventDef)) return [
            'timed',
            'allDay'
        ];
        return [
            'allDay'
        ];
    }
}
const $0b388de944c7beb8$var$DEFAULT_SLAT_LABEL_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'short'
});
function $0b388de944c7beb8$var$TimeColsAxisCell(props) {
    let classNames = [
        'fc-timegrid-slot',
        'fc-timegrid-slot-label',
        props.isLabeled ? 'fc-scrollgrid-shrink' : 'fc-timegrid-slot-minor'
    ];
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7c866399fa523f5).Consumer, null, (context)=>{
        if (!props.isLabeled) return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
            className: classNames.join(' '),
            "data-time": props.isoTimeStr
        });
        let { dateEnv: dateEnv, options: options, viewApi: viewApi } = context;
        let labelFormat = options.slotLabelFormat == null ? $0b388de944c7beb8$var$DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(options.slotLabelFormat[0]) : (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(options.slotLabelFormat);
        let renderProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
            elTag: "td",
            elClasses: classNames,
            elAttrs: {
                'data-time': props.isoTimeStr
            },
            renderProps: renderProps,
            generatorName: "slotLabelContent",
            customGenerator: options.slotLabelContent,
            defaultGenerator: $0b388de944c7beb8$var$renderInnerContent,
            classNameGenerator: options.slotLabelClassNames,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-slot-label-cushion',
                    'fc-scrollgrid-shrink-cushion'
                ]
            })));
    });
}
function $0b388de944c7beb8$var$renderInnerContent(props) {
    return props.text;
}
class $0b388de944c7beb8$var$TimeBodyAxis extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        return this.props.slatMetas.map((slatMeta)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                key: slatMeta.key
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColsAxisCell, Object.assign({}, slatMeta))));
    }
}
const $0b388de944c7beb8$var$DEFAULT_WEEK_NUM_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    week: 'short'
});
const $0b388de944c7beb8$var$AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
class $0b388de944c7beb8$export$667ac525945c6ff8 extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.allDaySplitter = new $0b388de944c7beb8$var$AllDaySplitter(); // for use by subclasses
        this.headerElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.rootElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.scrollerElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.state = {
            slatCoords: null
        };
        this.handleScrollTopRequest = (scrollTop)=>{
            let scrollerEl = this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ this.renderHeadAxis = (rowKey, frameHeight = '')=>{
            let { options: options } = this.context;
            let { dateProfile: dateProfile } = this.props;
            let range = dateProfile.renderRange;
            let dayCnt = (0, $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3)(range.start, range.end);
            // only do in day views (to avoid doing in week views that dont need it)
            let navLinkAttrs = dayCnt === 1 ? (0, $6e5ed45f0fbbb6e2$export$a17c37559e1db147)(this.context, range.start, 'week') : {};
            if (options.weekNumbers && rowKey === 'day') return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$1343a74baacb0543), {
                elTag: "th",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                date: range.start,
                defaultFormat: $0b388de944c7beb8$var$DEFAULT_WEEK_NUM_FORMAT
            }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        'fc-timegrid-axis-frame-liquid'
                    ].join(' '),
                    style: {
                        height: frameHeight
                    }
                }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ],
                    elAttrs: navLinkAttrs
                })));
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        this.renderTableRowAxis = (rowHeight)=>{
            let { options: options, viewApi: viewApi } = this.context;
            let renderProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $0b388de944c7beb8$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        rowHeight == null ? ' fc-timegrid-axis-frame-liquid' : ''
                    ].join(' '),
                    style: {
                        height: rowHeight
                    }
                }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                    elTag: "span",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ]
                }))));
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
        };
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    renderSimpleLayout(headerRowContent, allDayContent, timeContent) {
        let { context: context, props: props } = this;
        let sections = [];
        let stickyHeaderDates = (0, $6e5ed45f0fbbb6e2$export$89e9012e902952b6)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                chunk: {
                    content: allDayContent
                }
            });
            sections.push({
                type: 'body',
                key: 'all-day-divider',
                outerContent: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent
            }
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c667925124dac624), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [
                {
                    width: 'shrink'
                }
            ],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { context: context, props: props } = this;
        let stickyHeaderDates = !props.forPrint && (0, $6e5ed45f0fbbb6e2$export$89e9012e902952b6)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $6e5ed45f0fbbb6e2$export$4ad369a19af21c23)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            syncRowHeights: true,
            chunks: [
                {
                    key: 'axis',
                    rowContent: (arg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                            role: "presentation"
                        }, this.renderHeadAxis('day', arg.rowSyncHeights[0]))
                },
                {
                    key: 'cols',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: (contentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                                role: "presentation"
                            }, this.renderTableRowAxis(contentArg.rowSyncHeights[0]))
                    },
                    {
                        key: 'cols',
                        content: allDayContent
                    }
                ]
            });
            sections.push({
                key: 'all-day-divider',
                type: 'body',
                outerContent: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
                    colSpan: 2,
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        let isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: 'axis',
                    content: (arg)=>// TODO: make this now-indicator arrow more DRY with TimeColsContent
                        (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                            className: "fc-timegrid-axis-chunk"
                        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("table", {
                            "aria-hidden": true,
                            style: {
                                height: arg.expandRows ? arg.clientHeight : ''
                            }
                        }, arg.tableColGroupNode, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tbody", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeBodyAxis, {
                            slatMetas: slatMetas
                        }))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                            className: "fc-timegrid-now-indicator-container"
                        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf), {
                            unit: isNowIndicator ? 'minute' : 'day' /* hacky */ 
                        }, (nowDate)=>{
                            let nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                            if (typeof nowIndicatorTop === 'number') return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012), {
                                elClasses: [
                                    'fc-timegrid-now-indicator-arrow'
                                ],
                                elStyle: {
                                    top: nowIndicatorTop
                                },
                                isAxis: true,
                                date: nowDate
                            });
                            return null;
                        })))
                },
                {
                    key: 'cols',
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            key: 'footer',
            type: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'axis',
                    content: (0, $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290)
                },
                {
                    key: 'cols',
                    content: (0, $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290)
                }
            ]
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: false,
            colGroups: [
                {
                    width: 'shrink',
                    cols: [
                        {
                            width: 'shrink'
                        }
                    ]
                },
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ getAllDayMaxEventProps() {
        let { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows } = this.context.options;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            dayMaxEvents = undefined;
            dayMaxEventRows = $0b388de944c7beb8$var$AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return {
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows
        };
    }
}
function $0b388de944c7beb8$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
class $0b388de944c7beb8$export$bbb5c25f46ae511d {
    constructor(positions, dateProfile, slotDuration){
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    safeComputeTop(date) {
        let { dateProfile: dateProfile } = this;
        if ((0, $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4)(dateProfile.currentRange, date)) {
            let startOfDayDate = (0, $6e5ed45f0fbbb6e2$export$9e5f44173e64f162)(date);
            let timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= (0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(dateProfile.slotMinTime) && timeMs < (0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0)(timeMs));
        }
        return null;
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop(when, startOfDayDate) {
        if (!startOfDayDate) startOfDayDate = (0, $6e5ed45f0fbbb6e2$export$9e5f44173e64f162)(when);
        return this.computeTimeTop((0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0)(when.valueOf() - startOfDayDate.valueOf()));
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    computeTimeTop(duration) {
        let { positions: positions, dateProfile: dateProfile } = this;
        let len = positions.els.length;
        // floating-point value of # of slots covered
        let slatCoverage = (duration.milliseconds - (0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(dateProfile.slotMinTime)) / (0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(this.slotDuration);
        let slatIndex;
        let slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
    }
}
class $0b388de944c7beb8$var$TimeColsSlatsBody extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { slatElRefs: slatElRefs } = props;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tbody", null, props.slatMetas.map((slatMeta, i)=>{
            let renderProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi
            };
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
                key: slatMeta.key,
                ref: slatElRefs.createRef(slatMeta.key)
            }, props.axis && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColsAxisCell, Object.assign({}, slatMeta)), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-slot',
                    'fc-timegrid-slot-lane',
                    !slatMeta.isLabeled && 'fc-timegrid-slot-minor'
                ],
                elAttrs: {
                    'data-time': slatMeta.isoTimeStr
                },
                renderProps: renderProps,
                generatorName: "slotLaneContent",
                customGenerator: options.slotLaneContent,
                classNameGenerator: options.slotLaneClassNames,
                didMount: options.slotLaneDidMount,
                willUnmount: options.slotLaneWillUnmount
            }));
        }));
    }
}
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ class $0b388de944c7beb8$var$TimeColsSlats extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.slatElRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.rootElRef,
            className: "fc-timegrid-slots"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("table", {
            "aria-hidden": true,
            className: context.theme.getClass('table'),
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth,
                height: props.minHeight
            }
        }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColsSlatsBody, {
            slatElRefs: this.slatElRefs,
            axis: props.axis,
            slatMetas: props.slatMetas
        })));
    }
    componentDidMount() {
        this.updateSizing();
    }
    componentDidUpdate() {
        this.updateSizing();
    }
    componentWillUnmount() {
        if (this.props.onCoords) this.props.onCoords(null);
    }
    updateSizing() {
        let { context: context, props: props } = this;
        if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
        ) {
            let rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) props.onCoords(new $0b388de944c7beb8$export$bbb5c25f46ae511d(new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(this.rootElRef.current, $0b388de944c7beb8$var$collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
        }
    }
}
function $0b388de944c7beb8$var$collectSlatEls(elMap, slatMetas) {
    return slatMetas.map((slatMeta)=>elMap[slatMeta.key]);
}
function $0b388de944c7beb8$var$splitSegsByCol(segs, colCnt) {
    let segsByCol = [];
    let i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function $0b388de944c7beb8$var$splitInteractionByCol(ui, colCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < colCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.col].segs.push(seg);
    }
    return byRow;
}
class $0b388de944c7beb8$var$TimeColMoreLink extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$87b6ab1c2cb8b955), {
            elClasses: [
                'fc-timegrid-more-link'
            ],
            elStyle: {
                top: props.top,
                bottom: props.bottom
            },
            allDayDate: null,
            moreCnt: props.hiddenSegs.length,
            allSegs: props.hiddenSegs,
            hiddenSegs: props.hiddenSegs,
            extraDateSpan: props.extraDateSpan,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            popoverContent: ()=>$0b388de944c7beb8$var$renderPlainFgSegs(props.hiddenSegs, props),
            defaultGenerator: $0b388de944c7beb8$var$renderMoreLinkInner,
            forceTimed: true
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-more-link-inner',
                    'fc-sticky'
                ]
            }));
    }
}
function $0b388de944c7beb8$var$renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function $0b388de944c7beb8$var$buildPositioning(segInputs, strictOrder, maxStackCnt) {
    let hierarchy = new (0, $6e5ed45f0fbbb6e2$export$766bf7dcfb630b6c)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let hiddenGroups = (0, $6e5ed45f0fbbb6e2$export$d76842aa27385215)(hiddenEntries);
    let web = $0b388de944c7beb8$var$buildWeb(hierarchy);
    web = $0b388de944c7beb8$var$stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    let segRects = $0b388de944c7beb8$var$webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function $0b388de944c7beb8$var$buildWeb(hierarchy) {
    const { entriesByLevel: entriesByLevel } = hierarchy;
    const buildNode = $0b388de944c7beb8$var$cacheable((level, lateral)=>level + ':' + lateral, (level, lateral)=>{
        let siblingRange = $0b388de944c7beb8$var$findNextLevelSegs(hierarchy, level, lateral);
        let nextLevelRes = $0b388de944c7beb8$var$buildNodes(siblingRange, buildNode);
        let entry = entriesByLevel[level][lateral];
        return [
            Object.assign(Object.assign({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return $0b388de944c7beb8$var$buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function $0b388de944c7beb8$var$buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    let { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd } = siblingRange;
    let lateral = lateralStart;
    let pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort($0b388de944c7beb8$var$cmpDescPressures);
    return [
        pairs.map($0b388de944c7beb8$var$extractNode),
        pairs[0][1]
    ];
}
function $0b388de944c7beb8$var$cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function $0b388de944c7beb8$var$extractNode(a) {
    return a[0];
}
function $0b388de944c7beb8$var$findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    let { levelCoords: levelCoords, entriesByLevel: entriesByLevel } = hierarchy;
    let subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    let afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    let levelCnt = levelCoords.length;
    let level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        let entries = entriesByLevel[level];
        let entry;
        let searchIndex = (0, $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c)(entries, subjectEntry.span.start, (0, $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b));
        let lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        let lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function $0b388de944c7beb8$var$stretchWeb(topLevelNodes, totalThickness) {
    const stretchNode = $0b388de944c7beb8$var$cacheable((node, startCoord, prevThickness)=>(0, $6e5ed45f0fbbb6e2$export$674f8f4247a5112e)(node), (node, startCoord, prevThickness)=>{
        let { nextLevelNodes: nextLevelNodes, thickness: thickness } = node;
        let allThickness = thickness + prevThickness;
        let thicknessFraction = thickness / allThickness;
        let endCoord;
        let newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else {
            for (let childNode of nextLevelNodes)if (endCoord === undefined) {
                let res = stretchNode(childNode, startCoord, allThickness);
                endCoord = res[0];
                newChildren.push(res[1]);
            } else {
                let res = stretchNode(childNode, endCoord, 0);
                newChildren.push(res[1]);
            }
        }
        let newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            Object.assign(Object.assign({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map((node)=>stretchNode(node, 0, 0)[1]);
}
// not sorted in any particular order
function $0b388de944c7beb8$var$webToRects(topLevelNodes) {
    let rects = [];
    const processNode = $0b388de944c7beb8$var$cacheable((node, levelCoord, stackDepth)=>(0, $6e5ed45f0fbbb6e2$export$674f8f4247a5112e)(node), (node, levelCoord, stackDepth)=>{
        let rect = Object.assign(Object.assign({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        let stackForward = 0;
        for (let node of nodes)stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function $0b388de944c7beb8$var$cacheable(keyFunc, workFunc) {
    const cache = {};
    return (...args)=>{
        let key = keyFunc(...args);
        return key in cache ? cache[key] : cache[key] = workFunc(...args);
    };
}
function $0b388de944c7beb8$var$computeSegVCoords(segs, colDate, slatCoords = null, eventMinHeight = 0) {
    let vcoords = [];
    if (slatCoords) for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let spanStart = slatCoords.computeDateTop(seg.start, colDate);
        let spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function $0b388de944c7beb8$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    let segInputs = [];
    let dumbSegs = []; // segs without coords
    for(let i = 0; i < segs.length; i += 1){
        let vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    let { segRects: segRects, hiddenGroups: hiddenGroups } = $0b388de944c7beb8$var$buildPositioning(segInputs, eventOrderStrict, eventMaxStack);
    let segPlacements = [];
    for (let segRect of segRects)segPlacements.push({
        seg: segs[segRect.index],
        rect: segRect
    });
    for (let dumbSeg of dumbSegs)segPlacements.push({
        seg: dumbSeg,
        rect: null
    });
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
const $0b388de944c7beb8$var$DEFAULT_TIME_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: false
});
class $0b388de944c7beb8$var$TimeColEvent extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$6735ce526161c7bd), Object.assign({}, this.props, {
            elClasses: [
                'fc-timegrid-event',
                'fc-v-event',
                this.props.isShort && 'fc-timegrid-event-short'
            ],
            defaultTimeFormat: $0b388de944c7beb8$var$DEFAULT_TIME_FORMAT
        }));
    }
}
class $0b388de944c7beb8$var$TimeCol extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.sortEventSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)((0, $6e5ed45f0fbbb6e2$export$a91cd623adc48128));
    }
    // TODO: memoize event-placement?
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let isSelectMirror = options.selectMirror;
        let mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
        let interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        let sortedFgSegs = this.sortEventSegs(props.fgEventSegs, options.eventOrder);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53), {
            elTag: "td",
            elRef: props.elRef,
            elClasses: [
                'fc-timegrid-col',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'gridcell'
            }, props.extraDataAttrs),
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-frame"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-bg"
            }, this.renderFillSegs(props.businessHourSegs, 'non-business'), this.renderFillSegs(props.bgEventSegs, 'bg-event'), this.renderFillSegs(props.dateSelectionSegs, 'highlight')), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror), 'mirror')), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-now-indicator-container"
            }, this.renderNowIndicator(props.nowIndicatorSegs)), (0, $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0)(options) && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-col-misc'
                ]
            })));
    }
    renderFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { props: props } = this;
        if (props.forPrint) return $0b388de944c7beb8$var$renderPlainFgSegs(sortedFgSegs, props);
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey);
    }
    renderPositionedFgSegs(segs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { eventMaxStack: eventMaxStack, eventShortHeight: eventShortHeight, eventOrderStrict: eventOrderStrict, eventMinHeight: eventMinHeight } = this.context.options;
        let { date: date, slatCoords: slatCoords, eventSelection: eventSelection, todayRange: todayRange, nowDate: nowDate } = this.props;
        let isMirror = isDragging || isResizing || isDateSelecting;
        let segVCoords = $0b388de944c7beb8$var$computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        let { segPlacements: segPlacements, hiddenGroups: hiddenGroups } = $0b388de944c7beb8$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map((segPlacement)=>{
            let { seg: seg, rect: rect } = segPlacement;
            let instanceId = seg.eventRange.instance.instanceId;
            let isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
            let vStyle = $0b388de944c7beb8$var$computeSegVStyle(rect && rect.span);
            let hStyle = !isMirror && rect ? this.computeSegHStyle(rect) : {
                left: 0,
                right: 0
            };
            let isInset = Boolean(rect) && rect.stackForward > 0;
            let isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: 'fc-timegrid-event-harness' + (isInset ? ' fc-timegrid-event-harness-inset' : ''),
                key: forcedKey || instanceId,
                style: Object.assign(Object.assign({
                    visibility: isVisible ? '' : 'hidden'
                }, vStyle), hStyle)
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                isShort: isShort
            }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange, nowDate))));
        }));
    }
    // will already have eventMinHeight applied because segInputs already had it
    renderHiddenGroups(hiddenGroups, segs) {
        let { extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize } = this.props;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, hiddenGroups.map((hiddenGroup)=>{
            let positionCss = $0b388de944c7beb8$var$computeSegVStyle(hiddenGroup.span);
            let hiddenSegs = $0b388de944c7beb8$var$compileSegsFromEntries(hiddenGroup.entries, segs);
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColMoreLink, {
                key: (0, $6e5ed45f0fbbb6e2$export$f438b12253c2b499)((0, $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73)(hiddenSegs)),
                hiddenSegs: hiddenSegs,
                top: positionCss.top,
                bottom: positionCss.bottom,
                extraDateSpan: extraDateSpan,
                dateProfile: dateProfile,
                todayRange: todayRange,
                nowDate: nowDate,
                eventSelection: eventSelection,
                eventDrag: eventDrag,
                eventResize: eventResize
            });
        }));
    }
    renderFillSegs(segs, fillType) {
        let { props: props, context: context } = this;
        let segVCoords = $0b388de944c7beb8$var$computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        let children = segVCoords.map((vcoords, i)=>{
            let seg = segs[i];
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                key: (0, $6e5ed45f0fbbb6e2$export$4d522598b426bb73)(seg.eventRange),
                className: "fc-timegrid-bg-harness",
                style: $0b388de944c7beb8$var$computeSegVStyle(vcoords)
            }, fillType === 'bg-event' ? (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$b02498c06ddfef28), Object.assign({
                seg: seg
            }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, props.todayRange, props.nowDate))) : (0, $6e5ed45f0fbbb6e2$export$b975d55abac2bbe3)(fillType));
        });
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, children);
    }
    renderNowIndicator(segs) {
        let { slatCoords: slatCoords, date: date } = this.props;
        if (!slatCoords) return null;
        return segs.map((seg, i)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012), {
                // key doesn't matter. will only ever be one
                key: i,
                elClasses: [
                    'fc-timegrid-now-indicator-line'
                ],
                elStyle: {
                    top: slatCoords.computeDateTop(seg.start, date)
                },
                isAxis: false,
                date: date
            }));
    }
    computeSegHStyle(segHCoords) {
        let { isRtl: isRtl, options: options } = this.context;
        let shouldOverlap = options.slotEventOverlap;
        let nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        let farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        let left; // amount of space from left edge, a fraction of the total width
        let right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
        farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        } else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        let props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + '%',
            right: right * 100 + '%'
        };
        if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[isRtl ? 'marginLeft' : 'marginRight'] = 20; // 10 is a guesstimate of the icon's width
        return props;
    }
}
function $0b388de944c7beb8$var$renderPlainFgSegs(sortedFgSegs, { todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }) {
    let hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, sortedFgSegs.map((seg)=>{
        let instanceId = seg.eventRange.instance.instanceId;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? 'hidden' : ''
            }
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColEvent, Object.assign({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange, nowDate))));
    }));
}
function $0b388de944c7beb8$var$computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: '',
        bottom: ''
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function $0b388de944c7beb8$var$compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map((segEntry)=>allSegs[segEntry.index]);
}
class $0b388de944c7beb8$var$TimeColsContent extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.splitFgEventSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitBgEventSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitBusinessHourSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitNowIndicatorSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitDateSelectionSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitEventDrag = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitInteractionByCol);
        this.splitEventResize = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$splitInteractionByCol);
        this.rootElRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.cellElRefs = new (0, $6e5ed45f0fbbb6e2$export$807f1ba34db587c7)();
    }
    render() {
        let { props: props, context: context } = this;
        let nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
        let colCnt = props.cells.length;
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        let nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-cols",
            ref: this.rootElRef
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth
            }
        }, props.tableColGroupNode, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", {
            role: "row"
        }, props.axis && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
            "aria-hidden": true,
            className: "fc-timegrid-col fc-timegrid-axis"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-col-frame"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-now-indicator-container"
        }, typeof nowIndicatorTop === 'number' && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012), {
            elClasses: [
                'fc-timegrid-now-indicator-arrow'
            ],
            elStyle: {
                top: nowIndicatorTop
            },
            isAxis: true,
            date: props.nowDate
        })))), props.cells.map((cell, i)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeCol, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                nowDate: props.nowDate,
                todayRange: props.todayRange,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                fgEventSegs: fgEventSegsByRow[i],
                bgEventSegs: bgEventSegsByRow[i],
                businessHourSegs: businessHourSegsByRow[i],
                nowIndicatorSegs: nowIndicatorSegsByRow[i],
                dateSelectionSegs: dateSelectionSegsByRow[i],
                eventDrag: eventDragByRow[i],
                eventResize: eventResizeByRow[i],
                slatCoords: props.slatCoords,
                eventSelection: props.eventSelection,
                forPrint: props.forPrint
            }))))));
    }
    componentDidMount() {
        this.updateCoords();
    }
    componentDidUpdate() {
        this.updateCoords();
    }
    updateCoords() {
        let { props: props } = this;
        if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
        ) props.onColCoords(new (0, $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8)(this.rootElRef.current, $0b388de944c7beb8$var$collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
    }
}
function $0b388de944c7beb8$var$collectCellEls(elMap, cells) {
    return cells.map((cell)=>elMap[cell.key]);
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ class $0b388de944c7beb8$export$6d0b14d80f61b392 extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.processSlotOptions = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$var$processSlotOptions);
        this.state = {
            slatCoords: null
        };
        this.handleRootEl = (el)=>{
            if (el) this.context.registerInteractiveComponent(this, {
                el: el,
                isHitComboAllowed: this.props.isHitComboAllowed
            });
            else this.context.unregisterInteractiveComponent(this);
        };
        this.handleScrollRequest = (request)=>{
            let { onScrollTopRequest: onScrollTopRequest } = this.props;
            let { slatCoords: slatCoords } = this.state;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    let top = slatCoords.computeTimeTop(request.time);
                    top = Math.ceil(top); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top) top += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top);
                }
                return true;
            }
            return false;
        };
        this.handleColCoords = (colCoords)=>{
            this.colCoords = colCoords;
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
            if (this.props.onSlatCoords) this.props.onSlatCoords(slatCoords);
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-body",
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColsSlats, {
            axis: props.axis,
            dateProfile: props.dateProfile,
            slatMetas: props.slatMetas,
            clientWidth: props.clientWidth,
            minHeight: props.expandRows ? props.clientHeight : '',
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.axis ? props.tableColGroupNode : null,
            onCoords: this.handleSlatCoords
        }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$var$TimeColsContent, {
            cells: props.cells,
            axis: props.axis,
            dateProfile: props.dateProfile,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            todayRange: props.todayRange,
            nowDate: props.nowDate,
            nowIndicatorSegs: props.nowIndicatorSegs,
            clientWidth: props.clientWidth,
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.tableColGroupNode,
            slatCoords: state.slatCoords,
            onColCoords: this.handleColCoords,
            forPrint: props.forPrint
        }));
    }
    componentDidMount() {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    }
    componentDidUpdate(prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    }
    componentWillUnmount() {
        this.scrollResponder.detach();
    }
    queryHit(positionLeft, positionTop) {
        let { dateEnv: dateEnv, options: options } = this.context;
        let { colCoords: colCoords } = this;
        let { dateProfile: dateProfile } = this.props;
        let { slatCoords: slatCoords } = this.state;
        let { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot } = this.processSlotOptions(this.props.slotDuration, options.snapDuration);
        let colIndex = colCoords.leftToIndex(positionLeft);
        let slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            let cell = this.props.cells[colIndex];
            let slatTop = slatCoords.positions.tops[slatIndex];
            let slatHeight = slatCoords.positions.getHeight(slatIndex);
            let partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            let localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            let snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            let dayDate = this.props.cells[colIndex].date;
            let time = (0, $6e5ed45f0fbbb6e2$export$acf3ba20e47771d)(dateProfile.slotMinTime, (0, $6e5ed45f0fbbb6e2$export$55ff3cc1821e8445)(snapDuration, snapIndex));
            let start = dateEnv.add(dayDate, time);
            let end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: Object.assign({
                    range: {
                        start: start,
                        end: end
                    },
                    allDay: false
                }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight
                },
                layer: 0
            };
        }
        return null;
    }
}
function $0b388de944c7beb8$var$processSlotOptions(slotDuration, snapDurationOverride) {
    let snapDuration = snapDurationOverride || slotDuration;
    let snapsPerSlot = (0, $6e5ed45f0fbbb6e2$export$479ac0420f53ed26)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
class $0b388de944c7beb8$export$ca63779cde537f3d extends (0, $6e5ed45f0fbbb6e2$export$e0c3a065614c6254) {
    sliceRange(range, dayRanges) {
        let segs = [];
        for(let col = 0; col < dayRanges.length; col += 1){
            let segRange = (0, $6e5ed45f0fbbb6e2$export$ae1af26003f05816)(range, dayRanges[col]);
            if (segRange) segs.push({
                start: segRange.start,
                end: segRange.end,
                isStart: segRange.start.valueOf() === range.start.valueOf(),
                isEnd: segRange.end.valueOf() === range.end.valueOf(),
                col: col
            });
        }
        return segs;
    }
}
class $0b388de944c7beb8$export$a1033d45b156b3eb extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.buildDayRanges = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$export$718c171dfac2fa3a);
        this.slicer = new $0b388de944c7beb8$export$ca63779cde537f3d();
        this.timeColsRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
    }
    render() {
        let { props: props, context: context } = this;
        let { dateProfile: dateProfile, dayTableModel: dayTableModel } = props;
        let { nowIndicator: nowIndicator, nextDayThreshold: nextDayThreshold } = context.options;
        let dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf), {
            unit: nowIndicator ? 'minute' : 'day'
        }, (nowDate, todayRange)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$export$6d0b14d80f61b392, Object.assign({
                ref: this.timeColsRef
            }, this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                forPrint: props.forPrint,
                axis: props.axis,
                dateProfile: dateProfile,
                slatMetas: props.slatMetas,
                slotDuration: props.slotDuration,
                cells: dayTableModel.cells[0],
                tableColGroupNode: props.tableColGroupNode,
                tableMinWidth: props.tableMinWidth,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                expandRows: props.expandRows,
                nowDate: nowDate,
                nowIndicatorSegs: nowIndicator && this.slicer.sliceNowDate(nowDate, dateProfile, nextDayThreshold, context, dayRanges),
                todayRange: todayRange,
                onScrollTopRequest: props.onScrollTopRequest,
                onSlatCoords: props.onSlatCoords
            })));
    }
}
function $0b388de944c7beb8$export$718c171dfac2fa3a(dayTableModel, dateProfile, dateEnv) {
    let ranges = [];
    for (let date of dayTableModel.headerDates)ranges.push({
        start: dateEnv.add(date, dateProfile.slotMinTime),
        end: dateEnv.add(date, dateProfile.slotMaxTime)
    });
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
const $0b388de944c7beb8$var$STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function $0b388de944c7beb8$export$717bdb379477c13e(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    let dayStart = new Date(0);
    let slatTime = slotMinTime;
    let slatIterator = (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0)(0);
    let labelInterval = explicitLabelInterval || $0b388de944c7beb8$var$computeLabelInterval(slotDuration);
    let metas = [];
    while((0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(slatTime) < (0, $6e5ed45f0fbbb6e2$export$4b170465d7badfa1)(slotMaxTime)){
        let date = dateEnv.add(dayStart, slatTime);
        let isLabeled = (0, $6e5ed45f0fbbb6e2$export$479ac0420f53ed26)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $6e5ed45f0fbbb6e2$export$4e222d082f82ee97)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $6e5ed45f0fbbb6e2$export$acf3ba20e47771d)(slatTime, slotDuration);
        slatIterator = (0, $6e5ed45f0fbbb6e2$export$acf3ba20e47771d)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function $0b388de944c7beb8$var$computeLabelInterval(slotDuration) {
    let i;
    let labelInterval;
    let slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = $0b388de944c7beb8$var$STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0)($0b388de944c7beb8$var$STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $6e5ed45f0fbbb6e2$export$479ac0420f53ed26)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
class $0b388de944c7beb8$export$4b78a540ee976f33 extends $0b388de944c7beb8$export$667ac525945c6ff8 {
    constructor(){
        super(...arguments);
        this.buildTimeColsModel = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$export$5596a640484dddd2);
        this.buildSlatMetas = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($0b388de944c7beb8$export$717bdb379477c13e);
    }
    render() {
        let { options: options, dateEnv: dateEnv, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let { dateProfile: dateProfile } = props;
        let dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        let splitProps = this.allDaySplitter.splitProps(props);
        let slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        let { dayMinWidth: dayMinWidth } = options;
        let hasAttachedAxis = !dayMinWidth;
        let hasDetachedAxis = dayMinWidth;
        let headerContent = options.dayHeaders && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$27d1aff6bea49709), {
            dates: dayTableModel.headerDates,
            dateProfile: dateProfile,
            datesRepDistinctDays: true,
            renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
        });
        let allDayContent = options.allDaySlot !== false && ((contentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $000f37fb542d3ff1$export$cd402b7558adf371), Object.assign({}, splitProps.allDay, {
                dateProfile: dateProfile,
                dayTableModel: dayTableModel,
                nextDayThreshold: options.nextDayThreshold,
                tableMinWidth: contentArg.tableMinWidth,
                colGroupNode: contentArg.tableColGroupNode,
                renderRowIntro: hasAttachedAxis ? this.renderTableRowAxis : null,
                showWeekNumbers: false,
                expandRows: false,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            }, this.getAllDayMaxEventProps())));
        let timeGridContent = (contentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($0b388de944c7beb8$export$a1033d45b156b3eb, Object.assign({}, splitProps.timed, {
                dayTableModel: dayTableModel,
                dateProfile: dateProfile,
                axis: hasAttachedAxis,
                slotDuration: options.slotDuration,
                slatMetas: slatMetas,
                forPrint: props.forPrint,
                tableColGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                onSlatCoords: this.handleSlatCoords,
                expandRows: contentArg.expandRows,
                onScrollTopRequest: this.handleScrollTopRequest
            }));
        return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    }
}
function $0b388de944c7beb8$export$5596a640484dddd2(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $6e5ed45f0fbbb6e2$export$ebb8f7cd71856fb9)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $6e5ed45f0fbbb6e2$export$1314441b8d04e1d5)(daySeries, false);
}
var $0b388de944c7beb8$var$css_248z = ".fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:\"\\00a0\"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:\"\\00a0-\\00a0\"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-arrow,.fc .fc-timegrid-now-indicator-line{pointer-events:none}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}";
(0, $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75)($0b388de944c7beb8$var$css_248z);





const $53d7eeecb99f83a4$var$OPTION_REFINERS = {
    allDaySlot: Boolean
};
var $53d7eeecb99f83a4$export$2e2bcd8739ae039 = (0, $e05f80c7548aefed$export$ae829ec7b2625219)({
    name: '@fullcalendar/timegrid',
    initialView: 'timeGridWeek',
    optionRefiners: $53d7eeecb99f83a4$var$OPTION_REFINERS,
    views: {
        timeGrid: {
            component: (0, $0b388de944c7beb8$export$4b78a540ee976f33),
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: '00:30:00',
            slotEventOverlap: true
        },
        timeGridDay: {
            type: 'timeGrid',
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: 'timeGrid',
            duration: {
                weeks: 1
            }
        }
    }
});





class $b8c2c0d1d1ba5be0$var$ListViewHeaderRow extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.state = {
            textId: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)()
        };
    }
    render() {
        let { theme: theme, dateEnv: dateEnv, options: options, viewApi: viewApi } = this.context;
        let { cellId: cellId, dayDate: dayDate, todayRange: todayRange } = this.props;
        let { textId: textId } = this.state;
        let dayMeta = (0, $6e5ed45f0fbbb6e2$export$e171bab687b50e0)(dayDate, todayRange);
        // will ever be falsy?
        let text = options.listDayFormat ? dateEnv.format(dayDate, options.listDayFormat) : '';
        // will ever be falsy? also, BAD NAME "alt"
        let sideText = options.listDaySideFormat ? dateEnv.format(dayDate, options.listDaySideFormat) : '';
        let renderProps = Object.assign({
            date: dateEnv.toDate(dayDate),
            view: viewApi,
            textId: textId,
            text: text,
            sideText: sideText,
            navLinkAttrs: (0, $6e5ed45f0fbbb6e2$export$a17c37559e1db147)(this.context, dayDate),
            sideNavLinkAttrs: (0, $6e5ed45f0fbbb6e2$export$a17c37559e1db147)(this.context, dayDate, 'day', false)
        }, dayMeta);
        // TODO: make a reusable HOC for dayHeader (used in daygrid/timegrid too)
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
            elTag: "tr",
            elClasses: [
                'fc-list-day',
                ...(0, $6e5ed45f0fbbb6e2$export$1a8f5705751d8277)(dayMeta, theme)
            ],
            elAttrs: {
                'data-date': (0, $6e5ed45f0fbbb6e2$export$56350196709588fc)(dayDate)
            },
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $b8c2c0d1d1ba5be0$var$renderInnerContent,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("th", {
                scope: "colgroup",
                colSpan: 3,
                id: cellId,
                "aria-labelledby": textId
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-list-day-cushion',
                    theme.getClass('tableCellShaded')
                ]
            })));
    }
}
function $b8c2c0d1d1ba5be0$var$renderInnerContent(props) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, props.text && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", Object.assign({
        id: props.textId,
        className: "fc-list-day-text"
    }, props.navLinkAttrs), props.text), props.sideText && /* not keyboard tabbable */ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", Object.assign({
        "aria-hidden": true,
        className: "fc-list-day-side-text"
    }, props.sideNavLinkAttrs), props.sideText));
}
const $b8c2c0d1d1ba5be0$var$DEFAULT_TIME_FORMAT = (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: 'short'
});
class $b8c2c0d1d1ba5be0$var$ListViewEventRow extends (0, $6e5ed45f0fbbb6e2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg, timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderId: dateHeaderId } = props;
        let timeFormat = options.eventTimeFormat || $b8c2c0d1d1ba5be0$var$DEFAULT_TIME_FORMAT;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$c1df809846363ebe), Object.assign({}, props, {
            elTag: "tr",
            elClasses: [
                'fc-list-event',
                seg.eventRange.def.url && 'fc-event-forced-url'
            ],
            defaultGenerator: ()=>$b8c2c0d1d1ba5be0$var$renderEventInnerContent(seg, context),
            seg: seg,
            timeText: "",
            disableDragging: true,
            disableResizing: true
        }), (InnerContent, eventContentArg)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, $b8c2c0d1d1ba5be0$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
                "aria-hidden": true,
                className: "fc-list-event-graphic"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                className: "fc-list-event-dot",
                style: {
                    borderColor: eventContentArg.borderColor || eventContentArg.backgroundColor
                }
            })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "td",
                elClasses: [
                    'fc-list-event-title'
                ],
                elAttrs: {
                    headers: `${eventHeaderId} ${dateHeaderId}`
                }
            })));
    }
}
function $b8c2c0d1d1ba5be0$var$renderEventInnerContent(seg, context) {
    let interactiveAttrs = (0, $6e5ed45f0fbbb6e2$export$6dabbe08653f866f)(seg, context);
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", Object.assign({}, interactiveAttrs), seg.eventRange.def.title);
}
function $b8c2c0d1d1ba5be0$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId) {
    let { options: options } = context;
    if (options.displayEventTime !== false) {
        let eventDef = seg.eventRange.def;
        let eventInstance = seg.eventRange.instance;
        let doAllDay = false;
        let timeText;
        if (eventDef.allDay) doAllDay = true;
        else if ((0, $6e5ed45f0fbbb6e2$export$9fa96a7d116ea3ce)(seg.eventRange.range)) {
            if (seg.isStart) timeText = (0, $6e5ed45f0fbbb6e2$export$2538633961795d6b)(seg, timeFormat, context, null, null, eventInstance.range.start, seg.end);
            else if (seg.isEnd) timeText = (0, $6e5ed45f0fbbb6e2$export$2538633961795d6b)(seg, timeFormat, context, null, null, seg.start, eventInstance.range.end);
            else doAllDay = true;
        } else timeText = (0, $6e5ed45f0fbbb6e2$export$2538633961795d6b)(seg, timeFormat, context);
        if (doAllDay) {
            let renderProps = {
                text: context.options.allDayText,
                view: context.viewApi
            };
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    'fc-list-event-time'
                ],
                elAttrs: {
                    headers: `${timeHeaderId} ${dateHeaderId}`
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $b8c2c0d1d1ba5be0$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            });
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("td", {
            className: "fc-list-event-time"
        }, timeText);
    }
    return null;
}
function $b8c2c0d1d1ba5be0$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/ class $b8c2c0d1d1ba5be0$export$84d0dd190d551cd1 extends (0, $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a) {
    constructor(){
        super(...arguments);
        this.computeDateVars = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)($b8c2c0d1d1ba5be0$var$computeDateVars);
        this.eventStoreToSegs = (0, $6e5ed45f0fbbb6e2$export$df995fae86a55f06)(this._eventStoreToSegs);
        this.state = {
            timeHeaderId: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)(),
            eventHeaderId: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)(),
            dateHeaderIdRoot: (0, $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6)()
        };
        this.setRootEl = (rootEl)=>{
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { props: props, context: context } = this;
        let { dayDates: dayDates, dayRanges: dayRanges } = this.computeDateVars(props.dateProfile);
        let eventSegs = this.eventStoreToSegs(props.eventStore, props.eventUiBases, dayRanges);
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd), {
            elRef: this.setRootEl,
            elClasses: [
                'fc-list',
                context.theme.getClass('table'),
                context.options.stickyHeaderDates !== false ? 'fc-list-sticky' : ''
            ],
            viewSpec: context.viewSpec
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$54c4fabc2291e9c0), {
            liquid: !props.isHeightAuto,
            overflowX: props.isHeightAuto ? 'visible' : 'hidden',
            overflowY: props.isHeightAuto ? 'visible' : 'auto'
        }, eventSegs.length > 0 ? this.renderSegList(eventSegs, dayDates) : this.renderEmptyMessage()));
    }
    renderEmptyMessage() {
        let { options: options, viewApi: viewApi } = this.context;
        let renderProps = {
            text: options.noEventsText,
            view: viewApi
        };
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$e7094788287c5e9b), {
            elTag: "div",
            elClasses: [
                'fc-list-empty'
            ],
            renderProps: renderProps,
            generatorName: "noEventsContent",
            customGenerator: options.noEventsContent,
            defaultGenerator: $b8c2c0d1d1ba5be0$var$renderNoEventsInner,
            classNameGenerator: options.noEventsClassNames,
            didMount: options.noEventsDidMount,
            willUnmount: options.noEventsWillUnmount
        }, (InnerContent)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-list-empty-cushion'
                ]
            }));
    }
    renderSegList(allSegs, dayDates) {
        let { theme: theme, options: options } = this.context;
        let { timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderIdRoot: dateHeaderIdRoot } = this.state;
        let segsByDay = $b8c2c0d1d1ba5be0$var$groupSegsByDay(allSegs); // sparse array
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf), {
            unit: "day"
        }, (nowDate, todayRange)=>{
            let innerNodes = [];
            for(let dayIndex = 0; dayIndex < segsByDay.length; dayIndex += 1){
                let daySegs = segsByDay[dayIndex];
                if (daySegs) {
                    let dayStr = (0, $6e5ed45f0fbbb6e2$export$56350196709588fc)(dayDates[dayIndex]);
                    let dateHeaderId = dateHeaderIdRoot + '-' + dayStr;
                    // append a day header
                    innerNodes.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($b8c2c0d1d1ba5be0$var$ListViewHeaderRow, {
                        key: dayStr,
                        cellId: dateHeaderId,
                        dayDate: dayDates[dayIndex],
                        todayRange: todayRange
                    }));
                    daySegs = (0, $6e5ed45f0fbbb6e2$export$a91cd623adc48128)(daySegs, options.eventOrder);
                    for (let seg of daySegs)innerNodes.push((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($b8c2c0d1d1ba5be0$var$ListViewEventRow, Object.assign({
                        key: dayStr + ':' + seg.eventRange.instance.instanceId /* are multiple segs for an instanceId */ ,
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: false,
                        timeHeaderId: timeHeaderId,
                        eventHeaderId: eventHeaderId,
                        dateHeaderId: dateHeaderId
                    }, (0, $6e5ed45f0fbbb6e2$export$993a080e5cb62d74)(seg, todayRange, nowDate))));
                }
            }
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("table", {
                className: 'fc-list-table ' + theme.getClass('table')
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("thead", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tr", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                id: timeHeaderId
            }, options.timeHint), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                "aria-hidden": true
            }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                id: eventHeaderId
            }, options.eventHint))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("tbody", null, innerNodes));
        });
    }
    _eventStoreToSegs(eventStore, eventUiBases, dayRanges) {
        return this.eventRangesToSegs((0, $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f)(eventStore, eventUiBases, this.props.dateProfile.activeRange, this.context.options.nextDayThreshold).fg, dayRanges);
    }
    eventRangesToSegs(eventRanges, dayRanges) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.eventRangeToSegs(eventRange, dayRanges));
        return segs;
    }
    eventRangeToSegs(eventRange, dayRanges) {
        let { dateEnv: dateEnv } = this.context;
        let { nextDayThreshold: nextDayThreshold } = this.context.options;
        let range = eventRange.range;
        let allDay = eventRange.def.allDay;
        let dayIndex;
        let segRange;
        let seg;
        let segs = [];
        for(dayIndex = 0; dayIndex < dayRanges.length; dayIndex += 1){
            segRange = (0, $6e5ed45f0fbbb6e2$export$ae1af26003f05816)(range, dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    component: this,
                    eventRange: eventRange,
                    start: segRange.start,
                    end: segRange.end,
                    isStart: eventRange.isStart && segRange.start.valueOf() === range.start.valueOf(),
                    isEnd: eventRange.isEnd && segRange.end.valueOf() === range.end.valueOf(),
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when range won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !allDay && dayIndex + 1 < dayRanges.length && range.end < dateEnv.add(dayRanges[dayIndex + 1].start, nextDayThreshold)) {
                    seg.end = range.end;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    }
}
function $b8c2c0d1d1ba5be0$var$renderNoEventsInner(renderProps) {
    return renderProps.text;
}
function $b8c2c0d1d1ba5be0$var$computeDateVars(dateProfile) {
    let dayStart = (0, $6e5ed45f0fbbb6e2$export$9e5f44173e64f162)(dateProfile.renderRange.start);
    let viewEnd = dateProfile.renderRange.end;
    let dayDates = [];
    let dayRanges = [];
    while(dayStart < viewEnd){
        dayDates.push(dayStart);
        dayRanges.push({
            start: dayStart,
            end: (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(dayStart, 1)
        });
        dayStart = (0, $6e5ed45f0fbbb6e2$export$625550452a3fa3ec)(dayStart, 1);
    }
    return {
        dayDates: dayDates,
        dayRanges: dayRanges
    };
}
// Returns a sparse array of arrays, segs grouped by their dayIndex
function $b8c2c0d1d1ba5be0$var$groupSegsByDay(segs) {
    let segsByDay = []; // sparse array
    let i;
    let seg;
    for(i = 0; i < segs.length; i += 1){
        seg = segs[i];
        (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
    }
    return segsByDay;
}
var $b8c2c0d1d1ba5be0$var$css_248z = ":root{--fc-list-event-dot-width:10px;--fc-list-event-hover-bg-color:#f5f5f5}.fc-theme-standard .fc-list{border:1px solid var(--fc-border-color)}.fc .fc-list-empty{align-items:center;background-color:var(--fc-neutral-bg-color);display:flex;height:100%;justify-content:center}.fc .fc-list-empty-cushion{margin:5em 0}.fc .fc-list-table{border-style:hidden;width:100%}.fc .fc-list-table tr>*{border-left:0;border-right:0}.fc .fc-list-sticky .fc-list-day>*{background:var(--fc-page-bg-color);position:sticky;top:0}.fc .fc-list-table thead{left:-10000px;position:absolute}.fc .fc-list-table tbody>tr:first-child th{border-top:0}.fc .fc-list-table th{padding:0}.fc .fc-list-day-cushion,.fc .fc-list-table td{padding:8px 14px}.fc .fc-list-day-cushion:after{clear:both;content:\"\";display:table}.fc-theme-standard .fc-list-day-cushion{background-color:var(--fc-neutral-bg-color)}.fc-direction-ltr .fc-list-day-text,.fc-direction-rtl .fc-list-day-side-text{float:left}.fc-direction-ltr .fc-list-day-side-text,.fc-direction-rtl .fc-list-day-text{float:right}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:0}.fc-direction-rtl .fc-list-table .fc-list-event-graphic{padding-left:0}.fc .fc-list-event.fc-event-forced-url{cursor:pointer}.fc .fc-list-event:hover td{background-color:var(--fc-list-event-hover-bg-color)}.fc .fc-list-event-graphic,.fc .fc-list-event-time{white-space:nowrap;width:1px}.fc .fc-list-event-dot{border:calc(var(--fc-list-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-list-event-dot-width)/2);box-sizing:content-box;display:inline-block;height:0;width:0}.fc .fc-list-event-title a{color:inherit;text-decoration:none}.fc .fc-list-event.fc-event-forced-url:hover a{text-decoration:underline}";
(0, $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75)($b8c2c0d1d1ba5be0$var$css_248z);




const $99a414c136796239$var$OPTION_REFINERS = {
    listDayFormat: $99a414c136796239$var$createFalsableFormatter,
    listDaySideFormat: $99a414c136796239$var$createFalsableFormatter,
    noEventsClassNames: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    noEventsContent: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    noEventsDidMount: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5),
    noEventsWillUnmount: (0, $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5)
};
function $99a414c136796239$var$createFalsableFormatter(input) {
    return input === false ? null : (0, $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3)(input);
}
var $99a414c136796239$export$2e2bcd8739ae039 = (0, $e05f80c7548aefed$export$ae829ec7b2625219)({
    name: '@fullcalendar/list',
    optionRefiners: $99a414c136796239$var$OPTION_REFINERS,
    views: {
        list: {
            component: (0, $b8c2c0d1d1ba5be0$export$84d0dd190d551cd1),
            buttonTextKey: 'list',
            listDayFormat: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        listDay: {
            type: 'list',
            duration: {
                days: 1
            },
            listDayFormat: {
                weekday: 'long'
            }
        },
        listWeek: {
            type: 'list',
            duration: {
                weeks: 1
            },
            listDayFormat: {
                weekday: 'long'
            },
            listDaySideFormat: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        listMonth: {
            type: 'list',
            duration: {
                month: 1
            },
            listDaySideFormat: {
                weekday: 'long'
            }
        },
        listYear: {
            type: 'list',
            duration: {
                year: 1
            },
            listDaySideFormat: {
                weekday: 'long'
            }
        }
    }
});


async function $3b89005fd0863ad1$export$c6f7f92c8cfb6140() {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;
    const calendar = new (0, $e05f80c7548aefed$export$e1aef45b828286de)(calendarEl, {
        plugins: [
            (0, $ff6c31a575eac43e$export$2e2bcd8739ae039),
            (0, $53d7eeecb99f83a4$export$2e2bcd8739ae039),
            (0, $99a414c136796239$export$2e2bcd8739ae039)
        ],
        initialView: 'dayGridMonth',
        height: 'auto',
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,listWeek'
        },
        events: [
            {
                title: "\uD83D\uDC3E Pet Adoption Day",
                start: '2025-10-28',
                description: "\uD83D\uDCCD SM Seaside, Cebu",
                backgroundColor: '#4CAF50'
            },
            {
                title: "\uD83D\uDC89 Free Vaccination Drive",
                start: '2025-11-05',
                description: "\uD83D\uDCCD Ayala Center Cebu",
                backgroundColor: '#FF9800'
            },
            {
                title: "\uD83D\uDC36 Pet Care Workshop",
                start: '2025-11-15',
                description: "\uD83D\uDCCD IT Park, Cebu City",
                backgroundColor: '#2196F3'
            }
        ],
        eventClick (info) {
            // Get modal elements
            const modal = document.getElementById('event-modal');
            const modalTitle = modal.querySelector('.modal-title');
            const modalBody = modal.querySelector('.modal-body');
            const closeBtn = modal.querySelector('.close-btn');
            // Fill content dynamically
            modalTitle.textContent = info.event.title;
            modalBody.innerHTML = `
        <p>${info.event.extendedProps.description || "No description available."}</p>
        <p><strong>Start:</strong> ${info.event.start.toLocaleString()}</p>
        ${info.event.end ? `<p><strong>End:</strong> ${info.event.end.toLocaleString()}</p>` : ""}
      `;
            // ✅ Show modal
            modal.classList.add('show');
            // ✅ Close when clicking the close button
            closeBtn.onclick = ()=>modal.classList.remove('show');
            // ✅ Close when clicking outside the modal content
            window.onclick = (e)=>{
                if (e.target === modal) modal.classList.remove('show');
            };
            // ✅ Close on "Escape" key
            document.onkeydown = (e)=>{
                if (e.key === 'Escape') modal.classList.remove('show');
            };
        }
    });
    setTimeout(()=>{
        calendar.render();
        const observer = new ResizeObserver(()=>calendar.updateSize());
        observer.observe(calendarEl);
        calendar.updateSize();
    }, 3000);
}


// vetShelter.js
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
// import markerIcon from 'leaflet/dist/images/marker-icon.png';
// import markerShadow from 'leaflet/dist/images/marker-shadow.png';
function $926af10ef6c800ea$export$155126335032bf37() {
    setTimeout(()=>{
        const mapContainer = document.getElementById("vet-map");
        const listContainer = document.getElementById("vet-list");
        if (!mapContainer || !listContainer) {
            console.error("Vet/Shelter section not found!");
            return;
        }
        // delete L.Icon.Default.prototype._getIconUrl;
        // L.Icon.Default.mergeOptions({
        //   iconRetinaUrl: markerIcon2x,
        //   iconUrl: markerIcon,
        //   shadowUrl: markerShadow,
        // });
        // ✅ Initialize map
        const map = L.map("vet-map").setView([
            10.3157,
            123.8854
        ], 12); // Cebu City default
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);
        // ✅ Example vet/shelter data
        const places = [
            {
                name: "Happy Paws Veterinary Clinic",
                address: "Fuente Osmena, Cebu City",
                type: "Vet Clinic",
                coords: [
                    10.3102,
                    123.8931
                ]
            },
            {
                name: "Cebu Animal Care Shelter",
                address: "Talisay City, Cebu",
                type: "Shelter",
                coords: [
                    10.3195,
                    123.9054
                ]
            },
            {
                name: "FurEver Friends Vet Center",
                address: "Lahug, Cebu City",
                type: "Vet Clinic",
                coords: [
                    10.3268,
                    123.9158
                ]
            }
        ];
        // ✅ Add markers
        const markers = places.map((place)=>{
            const marker = L.marker(place.coords).addTo(map);
            marker.bindPopup(`
        <strong>${place.name}</strong><br>
        \u{1F4CD} ${place.address}<br>
        \u{1FA7A} ${place.type}<br><br>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${place.coords[0]},${place.coords[1]}"
           target="_blank"
           style="color:#0078d7;">\u{27A1}\u{FE0F} Get Directions</a>
      `);
            return marker;
        });
        // ✅ Render list items
        listContainer.innerHTML = places.map((place, index)=>`
        <div class="vet-item" data-index="${index}">
          <h3>${place.name}</h3>
          <p>${place.address}</p>
          <span>${place.type}</span>
        </div>
      `).join("");
        // ✅ Click to pan + highlight
        listContainer.addEventListener("click", (e)=>{
            const item = e.target.closest(".vet-item");
            if (!item) return;
            const index = item.dataset.index;
            const marker = markers[index];
            map.setView(places[index].coords, 15, {
                animate: true
            });
            marker.openPopup();
            document.querySelectorAll(".vet-item").forEach((el)=>el.classList.remove("active"));
            item.classList.add("active");
        });
        setTimeout(()=>map.invalidateSize(), 1000);
    }, 500); // delay to ensure map container is visible
}


const $212038711ef1a1fe$var$select = document.getElementById('breed-select');
const $212038711ef1a1fe$var$img = document.getElementById('dog-img');
const $212038711ef1a1fe$var$name = document.getElementById('dog-name');
const $212038711ef1a1fe$var$loader = document.getElementById('loader');
async function $212038711ef1a1fe$var$loadBreeds() {
    $212038711ef1a1fe$var$loader.textContent = "Loading breeds... \uD83D\uDC3E";
    try {
        const breeds = await (0, $d322b1c958656062$export$74b7fa354111de1c)();
        $212038711ef1a1fe$var$loader.textContent = "";
        for(const breed in breeds)if (breeds[breed].length) breeds[breed].forEach((sub)=>{
            const option = document.createElement('option');
            option.value = `${breed}/${sub}`;
            option.textContent = `${breed} (${sub})`;
            $212038711ef1a1fe$var$select.appendChild(option);
        });
        else {
            const option = document.createElement('option');
            option.value = breed;
            option.textContent = breed;
            $212038711ef1a1fe$var$select.appendChild(option);
        }
    } catch (error) {
        $212038711ef1a1fe$var$loader.textContent = error.message || "Failed to load breeds.";
    }
}
async function $212038711ef1a1fe$var$showDog() {
    const breed = $212038711ef1a1fe$var$select.value;
    if (!breed) {
        $212038711ef1a1fe$var$img.style.display = "none";
        $212038711ef1a1fe$var$name.textContent = "";
        $212038711ef1a1fe$var$loader.textContent = "Select a breed to see a dog \uD83D\uDC3E";
        return;
    }
    $212038711ef1a1fe$var$loader.textContent = "Loading dog... \uD83D\uDC15\u200D\uD83E\uDDBA";
    $212038711ef1a1fe$var$img.style.display = "none";
    $212038711ef1a1fe$var$name.textContent = "";
    try {
        const dogUrl = await (0, $d322b1c958656062$export$a97658d36297bf4c)(breed);
        $212038711ef1a1fe$var$img.src = dogUrl;
        $212038711ef1a1fe$var$img.style.display = "block";
        $212038711ef1a1fe$var$name.textContent = breed.replace('/', ' ');
        $212038711ef1a1fe$var$loader.textContent = "";
    } catch (error) {
        $212038711ef1a1fe$var$loader.textContent = error.message || "Failed to load dog image.";
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $fa7a60d60ed0fb7b$export$db4f8e1f9297af79)();
    (0, $796c3155ab639a9c$export$4e45a93c820471fa)();
    $212038711ef1a1fe$var$loadBreeds();
    (0, $050486e8e3cb883c$export$f0c7f3aad087f331)(document.getElementById('gallery'), document.getElementById('loader'), 15);
    $212038711ef1a1fe$var$select.addEventListener("change", $212038711ef1a1fe$var$showDog);
    (0, $3b89005fd0863ad1$export$c6f7f92c8cfb6140)();
    (0, $926af10ef6c800ea$export$155126335032bf37)();
    AOS.init();
});


//# sourceMappingURL=repo.1855d20b.js.map
